import axiosClient from 'api/axiosClient';
import store from 'app/store';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import * as Yup from 'yup';
import DialogActivateChargeConnectorView from './ChargeConnector/components/DialogActivateChargeConnectorView';
import DialogTopUpDriverView from './ChargeDriver/components/DialogTopUpDriverView';
import DialogTransactionDetailView from './ChargeDriver/components/DialogTransactionDetailView';
import ChargePointSetLimitPowerView from './ChargePoint/components/ChargePointSetLimitPowerView';
import DialogMovePointView from './ChargePoint/components/DialogMovePointView';
import FirmwareHistoryView from './ChargePoint/components/FirmwareHistoryView';
import DialogUpdateFirmwareView from './ChargePoint/components/DialogUpdateFirmwareView';
import DialogReportErrorChargePointView from './ChargePoint/components/DialogReportErrorChargePointView';
import DialogChargePointErrorDescriptionView from './ChargePoint/components/DialogChargePointErrorDescriptionView';
import DialogChangeRfidCardView from './ChargeRFID/components/DialogChangeRfidCardView';
import DialogStopChargeStationView from './ChargeStation/components/DialogStopChargeStationView';
import DialogSetChargingPriceView from './ChargeDriver/components/DialogSetChargingPriceView';
import DialogChangeAgencyPasswordView from 'features/ManageDealer/components/DialogChangeAgencyPasswordView';
import DialogDownloadExcelFile from 'features/System/Excel/components/DialogDownloadExcelFile';
import DialogUploadIdentifierView from 'features/Charge/ChargeIdentifier/components/DialogUploadIdentifierView';
import DialogUploadIdentifierInvalidDataView from 'features/Charge/ChargeIdentifier/components/DialogUploadIdentifierInvalidDataView';
import DialogAssignVehicleView from 'features/Charge/ChargeIdentifier/components/DialogAssignVehicleView';

// MARK: ---- CONSTANTS ----
export const ChargeConstants = {
  // ---- USER ----
  UserRole: {
    ADMIN: 'ADMIN', // Quản trị viên
    OPERATOR: 'OPERATOR', // Nhà điều hành
    AGENCY: 'AGENCY', // Đại lý
    DRIVER: 'DRIVER', // Khách hàng
    MAINTAINER: 'MAINTAINER', // Người bảo trì
  },
  // ---- KHACH HANG ----
  ChargeDriverStatus: {
    REGISTERED: 'REGISTERED', // Đã đăng ký
    NORMAL: 'NORMAL', // Đang hoạt động
    SUSPENDED: 'SUSPENDED', // Ngừng hoạt động
    DELETED: 'DELETED', // Đã xóa
  },

  ChargeDriverPricingType: {
    STANDARD: 'STANDARD', // Tiêu chuẩn
    DISCOUNT: 'DISCOUNT', // Ưu đãi
    FREE: 'FREE', // Miễn phí
  },

  // ---- THE RFID ----
  RFIDCardStatus: {
    NORMAL: 'NORMAL', // Đang hoạt động
    BLOCKED: 'BLOCKED', // Bị khóa
  },

    // ---- TRẠNG THÁI TRẠM SẠC ----
    ChargeStationStatus: {
      NORMAL: 'NORMAL', // Đang hoạt động
      MAINTAINING: 'MAINTAINING', // Đang bảo trì
      PENDING: 'PENDING', // Đang lắp đặt
      DISCONNECTED: 'DISCONNECTED', // Mất kết nối
      STOPPED: 'STOPPED', // Ngừng hoạt động
      HIDDEN: 'HIDDEN', // Đang ẩn
      DELETED: 'DELETED', // Đã xóa
    },

  // ---- TRẠNG THÁI TRỤ SẠC ----
  ChargePointStatus: {
    AVAILABLE: 'AVAILABLE', // Sẵn sàng
    BUSY: 'BUSY', // Đang bận
    FAULT: 'FAULT', // Lỗi
    MAINTAINING: 'MAINTAINING', // Bảo trì
    DISCONNECTED: 'DISCONNECTED', // Mất kết nối
    DISABLE: 'DISABLE', // Vô hiệu hóa
    RESERVED: 'RESERVED', // Đang đặt chỗ
  },
  ChargePointType: {
    AC: 'AC', // AC
    DC: 'DC', // DC
  },

  // ---- TRẠNG THÁI CỦA SÚNG SẠC ----
  ChargeConnectorStatus: {
    AVAILABLE: 'AVAILABLE', // Sẵn sàng
    UNAVAILABLE: 'UNAVAILABLE', // Không khả dụng
    PREPARING: 'PREPARING', // Đang chuẩn bị
    CHARGING: 'CHARGING', // Đang sạc
    SUSPENDED: 'SUSPENDED', // Đang tạm dừng
    FINISHING: 'FINISHING', // Đang kết thúc
    FAULTED: 'FAULTED', // Lỗi
    RESERVED: 'RESERVED', // Đang đặt chỗ
  },
  ChargeConnectorType: {
    J1772: 'J1772',
    Mennekes: 'Mennekes',
    GB_T: 'GB/T',
    CHAdeMO: 'CHAdeMO',
    CCS1: 'CCS1',
    CCS2: 'CCS2',
    Tesla: 'Tesla',
    AC: 'AC',
  },

  // ---- THONG BAO ----
  MessageLogType: {
    INFO: 'INFO', // Thông tin
    NOTICE: 'NOTICE', // Thông báo
    WARNING: 'WARNING', // Cảnh báo
    ERROR: 'ERROR', // Lỗi
  },

  // ---- DINH GIA SAC ----
  ChargePricingMode: {
    FLAT: 'FLAT', // Cố định
    HOURS: 'HOURS', // Theo giờ
    TIERED: 'TIERED', // Bậc thang
  },

  // ---- PHUONG THUC THANH TOAN ----
  ChargePaymentMethod: {
    WALLET: 'WALLET', // Ví điện tử
    CASH: 'CASH', // Tiền mặt
    QR: 'QR', // QR Code
    VNPAY: 'VNPAY', // VNPAY
    MOMO: 'MOMO', // MOMO
    INTERNAL: 'INTERNAL', // Nạp nội bộ
    REFUND: 'REFUND', // Hoàn tiền
  },

  // ---- PHIEN SAC ----
  ChargeTransactionStatus: {
    INITIATING: 'INITIATING', // Khởi tạo
    PREPARING: 'PREPARING', // Chuẩn bị, voi sac da cam
    CHARGING: 'CHARGING', // Dang sac
    FINISHING: 'FINISHING', // Dang ket thuc, chua rut voi sac
    FINISHED: 'FINISHED', // Da ket thuc
    CANCELLED: 'CANCELLED', // Da huy
    FAILED: 'FAILED', // Loi
    RESERVED: 'RESERVED', // Dang dat cho
  },

  // ---- KHAC ----
  VehicleType: {
    CAR: 'CAR',
    BIKE: 'BIKE',
  },
  VehicleChargingMode: {
    NORMAL: 'NORMAL',
    SMART: 'SMART',
  },
  VehicleFlugChargeRequiresRegistrationMessage:
    'Bật tính năng thất bại. Tài xế chưa đăng ký sạc nhận diện xe hoặc chưa được khai báo mã định danh (MAC/EVCC).',
  EnergyAccountStatus: {
    PENDING: 'PENDING', // Chờ xác nhận
    VALIDATED: 'VALIDATED', // Đã xác nhận
  },
  VehicleStatus: {
    NORMAL: 'NORMAL', // Đang hoạt động
    DELETED: 'DELETED', // Đã xóa
    PENDING: 'PENDING', // Chờ xác nhận
  },
  ChargePaymentStatus: {
    PENDING: 'PENDING', // Chờ xác nhận
    COMPLETED: 'COMPLETED', // Đã thanh toán
    FAILED: 'FAILED', // Thất bại
    CANCELLED: 'CANCELLED', // Đã hủy
  },
  WalletTransactionStatus: {
    PENDING: 'PENDING', //Chờ thanh toán
    COMPLETED: 'COMPLETED', //Hoàn thành
    CANCELLED: 'CANCELLED', //Đã hủy
    FAILED: 'FAILED', //Thất bại
  },
  DashboardRevenueType: {
    INVESTOR: 'INVESTOR',
    COINVESTOR: 'COINVESTOR',
    GROUP: 'GROUP',
    ENERGY: 'ENERGY',
    CHARGEPOINT: 'CHARGEPOINT',
  },
  TutorialStatus: {
    NORMAL: 'NORMAL',
    DELETED: 'DELETED',
  },
  TutorialObject: {
    DRIVER: 'DRIVER',
    AGENCY: 'AGENCY',
  },
  networkOperator: {
    VIETTEL: 'VIETTEL',
    VINAPHONE: 'VINAPHONE',
  },
  NotificationStatus: {
    SCHEDULED: 'SCHEDULED',
    SENT: 'SENT',
    HIDDEN: 'HIDDEN',
  },
  NotificationCategory: {
    BUSINESS: 'BUSINESS',
    OPERATION: 'OPERATION',
    PROMOTION: 'PROMOTION',
    CHARGE: 'CHARGE',
    OTHER: 'OTHER',
    EVG: 'EVG',
  },
  ChargeIdentifierStatus: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
  },
  ChargeIdentifierPartnerUnassignedDropdownValue: '__FILTER_NULL__',
};

const ChargeHelper = {
  // MARK: ---- FILTER ----
  Filter: {
    // danh sach tram sac
    chargeStationList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      operatorId: '',
      q: '',
      managedBy: '',
      agencyId: '',
      landlordId: '',
      areaId: '',
      vehicleType: '',
      type: '',
      isTestStation: 0,
    },
    // danh sach phien sac
    chargeTransactionList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      stationId: '',
      vehicleType: '',
      isTestTransaction: 0,
      exclusionZeroCost: false,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
    },
    // doi tac sac
    chargeIdentityPartnerList: {
      q: '',
      page: 0,
      limit: 10,
    },
    // hang san xuat tru sac
    chargeBrandList: {
      q: '',
      page: 0,
      limit: 10,
    },
    // dong tru sac
    chargeModelList: {
      q: '',
      page: 0,
      limit: 10,
    },
    // hang san xuat xe
    chargeVehicleBrandList: {
      q: '',
      vehicleType: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
    },
    // dong xe
    chargeVehicleModelList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
    },
    // xe
    chargeVehicleList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      brandId: '',
      modelId: '',
      autoCharge: '',
    },
    // rfid
    chargeRfidList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
    },
    // khach hang
    chargeDriverList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      pricingType: '',
      from: '',
      to: '',
      dateFilter: dateFilter.tatCaThoiGian,
      walletDepositFrom: '',
      walletDepositTo: '',
      transactionDateFilter: dateFilter.tatCaThoiGian,
    },
    // ma dinh danh
    chargeIdentifierList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      vehicleIdentityPartnerId: '',
    },
    // system log
    systemLogList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      category: '',
      userId: '',
      createdBy: 'SYSTEM',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      isSent: '',
    },
    // pricing
    chargePricingList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      operatorId: '',
      agencyId: '',
      pointId: '',
      managedBy: '',
    },
    driverTopUpHistoryList: {
      userId: '',
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      direction: 'IN',
      fundingSource: '',
    },
  },

  // MARK: ---- VALIDATION SCHEMA ----
  ValidationSchema: {
    // ---- TRAM SAC ----
    chargeStation: Yup.object({
      monthlyPremiseCost: Yup.number().nullable(),
      energyCost: Yup.number().nullable(),
      currency: Yup.string().nullable(),
      status: Yup.string().required('Vui lòng chọn trạng thái'),
      stationCode: Yup.string().nullable(),
      name: Yup.string().required('Vui lòng nhập tên trạm sạc'),
      description: Yup.string().nullable(),
      address: Yup.string().required('Vui lòng nhập địa chỉ'),
      phone: Yup.string()
        .required('Vui lòng nhập số điện thoại')
        .test('len', 'Số điện thoại không hợp lệ', (val) => {
          if (val) {
            return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
          }
        }),
      operatorId: Yup.string().required('Vui lòng chọn nhà điều hành'),
      agencyId: Yup.number().nullable(),
      landlordId: Yup.number().nullable(),
      latitude: Yup.string().nullable(),
      longitude: Yup.string().nullable(),
      image: Yup.string().nullable(),
      services: Yup.array().nullable(),
      contactName: Yup.string().required('Vui lòng nhập tên người liên hệ'),
      contactPhone: Yup.string()
        .required('Vui lòng nhập số điện thoại người liên hệ')
        .test('len', 'Số điện thoại không hợp lệ', (val) => {
          if (val) {
            return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
          }
        }),
      // isAgencyPayEnergyCost: Yup.string().required('Vui lòng chọn đối tượng thanh toán'),
      isAgencyPayEnergyCost: Yup.string().nullable(),
      // inputFlatPrice: Yup.string()
      //   .when('inputPricingMode', {
      //     is: 'FLAT',
      //     then: Yup.string()
      //       .required('Vui lòng nhập giá điện cố định')
      //       .test(
      //         'is-valid-number',
      //         'Giá điện cố định phải là số lớn hơn 0',
      //         (value) => {
      //           const number = Number(value);
      //           return !isNaN(number) && number > 0;
      //         }
      //       ),
      //     otherwise: Yup.string().nullable().notRequired(),
      //   }),
      inputFlatPrice: Yup.string().nullable(),
      // inputNormalPrice: Yup.string()
      //   .when('inputPricingMode', {
      //     is: 'HOURS',
      //     then: Yup.string()
      //       .required('Vui lòng nhập giá điện giờ bình thường')
      //       .test(
      //         'is-valid-number',
      //         'Giá điện giờ bình thường phải là số lớn hơn 0',
      //         (value) => {
      //           const number = Number(value);
      //           return !isNaN(number) && number > 0;
      //         }
      //       ),
      //     otherwise: Yup.string().nullable().notRequired(),
      //   }),
      inputNormalPrice: Yup.string().nullable(),
      // inputPeakPrice: Yup.string()
      //   .when('inputPricingMode', {
      //     is: 'HOURS',
      //     then: Yup.string()
      //       .required('Vui lòng nhập giá điện giờ cao điểm')
      //       .test(
      //         'is-valid-number',
      //         'Giá điện giờ cao điểm phải là số lớn hơn 0',
      //         (value) => {
      //           const number = Number(value);
      //           return !isNaN(number) && number > 0;
      //         }
      //       ),
      //     otherwise: Yup.string().nullable().notRequired(),
      //   }),
      inputPeakPrice: Yup.string().nullable(),
      // inputOffPeakPrice: Yup.string()
      //   .when('inputPricingMode', {
      //     is: 'HOURS',
      //     then: Yup.string()
      //       .required('Vui lòng nhập giá điện giờ thấp điểm')
      //       .test(
      //         'is-valid-number',
      //         'Giá điện giờ thấp điểm phải là số lớn hơn 0',
      //         (value) => {
      //           const number = Number(value);
      //           return !isNaN(number) && number > 0;
      //         }
      //       ),
      //     otherwise: Yup.string().nullable().notRequired(),
      //   }),
      inputOffPeakPrice: Yup.string().nullable(),
      // inputTieredPrice: Yup.array()
      //   .when('inputPricingMode', {
      //     is: 'TIERED',
      //     then: Yup.array()
      //       .of(
      //         Yup.object().shape({
      //           upto: Yup.number().required('Vui lòng nhập mức tiêu thụ'),
      //           price: Yup.number()
      //             .typeError('Giá phải là số')
      //             .required('Vui lòng nhập giá')
      //             .moreThan(0, 'Giá phải lớn hơn 0'),
      //         })
      //       )
      //       .min(1, 'Phải có ít nhất một mức giá')
      //       .test(
      //         'prices-not-decreasing',
      //         'Mỗi mức giá sau phải lớn hơn hoặc bằng mức giá trước',
      //         function (tieredPrices) {
      //           if (!Array.isArray(tieredPrices)) return true;
      //           for (let i = 1; i < tieredPrices.length; i++) {
      //             const prev = Number(tieredPrices[i - 1]?.price);
      //             const curr = Number(tieredPrices[i]?.price);
      //             if (!isFinite(prev) || !isFinite(curr)) continue;
      //             if (curr < prev) {
      //               return this.createError({
      //                 path: `inputTieredPrice[${i}].price`,
      //                 message: `Giá tại mức thứ ${i + 1} phải lớn hơn hoặc bằng mức trước`,
      //               });
      //             }
      //           }
      //           return true;
      //         }
      //       ),
      //     otherwise: Yup.array().nullable().notRequired(),
      //   }),
      inputTieredPrice: Yup.array().nullable(),

    }),
    getChargeStationValidationSchema(editMode = false) {
      return this.chargeStation.shape({
        stationCode: editMode
          ? Yup.string().required('Vui lòng nhập mã trạm sạc')
          : Yup.string().nullable(),
      });
    },
    // ---- TRU SAC ----
    chargePoint: Yup.object({
      pointId: Yup.string().nullable(),
      pointCode: Yup.string().nullable(),
      power: Yup.number().nullable(),
      name: Yup.string().required('Vui lòng nhập tên trụ sạc'),
      type: Yup.string().required('Vui lòng chọn loại trụ sạc'),
      modelId: Yup.string().required('Vui lòng chọn model'),
      // phoneNumber: Yup.string()
      //   .required('Vui lòng nhập số điện thoại')
      //   .test('len', 'Số điện thoại không hợp lệ', (val) => {
      //     if (_.isNil(val)) return true;
      //     if (val) {
      //       return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
      //     }
      //   }),
      phoneNumber: Yup.string().nullable(),
      numberConnectors: Yup.number().required('Vui lòng nhập số lượng súng sạc'),
      voltage: Yup.number().nullable(),
      maxAmpere: Yup.number().required('Vui lòng nhập dòng điện tối đa'),
      protocol: Yup.string().required('Vui lòng nhập giao thức'),
      ocppId: Yup.string().required('Vui lòng nhập CPID'),
      ocppPassword: Yup.string().required('Vui lòng nhập mật khẩu CPID'),
      image: Yup.string().nullable(),
      serialNumber: Yup.string().required('Vui lòng nhập số serial trụ sạc'),
      // iccid: Yup.string().required('Vui lòng nhập số serial SIM'),
      iccid: Yup.string().nullable(),
      // networkOperator: Yup.string().required('Vui lòng chọn nhà mạng'),
      networkOperator: Yup.string().nullable(),
      // dataPackage: Yup.string().required('Vui lòng nhập tên gói cước'),
      dataPackage: Yup.string().nullable(),
      // pricing
      freeOverchargeDuration: Yup.number().min(0, 'Thời gian không hợp lệ'), //.required('Vui lòng nhập thời gian sạc miễn phí'),
      overchargePrice: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá sạc quá giờ'),
      pricingMode: Yup.string(), //.required('Vui lòng chọn cách tính giá'),
      flatPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.FLAT,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá cố định'),
      }),
      normalPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.HOURS,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá giờ bình thường'),
      }),
      peakPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.HOURS,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá giờ cao điểm'),
      }),
      offPeakPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.HOURS,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá giờ thấp điểm'),
      }),
    }),
    getChargePointValidationSchema(editMode = false) {
      return this.chargePoint.shape({
        pointCode: editMode
          ? Yup.string().required('Vui lòng nhập mã trụ sạc')
          : Yup.string().nullable(),
      });
    },
    // ---- DOI TAC SAC ----
    chargeIdentityPartner: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên đối tác'),
      website: Yup.string().url('Địa chỉ website không hợp lệ').nullable(),
    }),
    // ---- HANG SAN XUAT TRU SAC ----
    chargeBrand: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên hãng sản xuất'),
      logo: Yup.string().required('Vui lòng chọn logo'),
      website: Yup.string().url('Địa chỉ website không hợp lệ').nullable(),
    }),
    // ---- MODEL TRU SAC ----
    chargeModel: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên model'),
      description: Yup.string().nullable(),
      image: Yup.string().required('Vui lòng chọn ảnh'),
      vehicleType: Yup.string().required('Vui lòng chọn loại phương tiện'),
      type: Yup.string().required('Vui lòng chọn loại trụ sạc'),
      protocol: Yup.string().required('Vui lòng nhập giao thức'),
      power: Yup.number()
        .required('Vui lòng nhập công suất')
        .test('is-valid-number', 'Công suất phải lớn hơn 0', (value) =>
          value ? !isNaN(Number(value)) && Number(value) > 0 : false
        ),
      voltage: Yup.number()
        .required('Vui lòng nhập điện áp')
        .test('is-valid-number', 'Điện áp phải lớn hơn 0', (value) =>
          value ? !isNaN(Number(value)) && Number(value) > 0 : false
        ),
      price: Yup.number()
        .required('Vui lòng nhập đơn giá')
        .min(0, 'Đơn giá phải lớn hơn hoặc bằng 0')
        .typeError('Đơn giá phải là một số hợp lệ'),
    }),
    // ---- HANG SAN XUAT XE ----
    chargeVehicleBrand: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên hãng xe'),
      logo: Yup.string().required('Vui lòng chọn logo'),
      vehicleTypes: Yup.string().required('Vui lòng chọn loại phương tiện'),
    }),
    // ---- DONG XE ----
    chargeVehicleModel: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên hãng xe'),
      image: Yup.string().required('Vui lòng chọn ảnh'),
      description: Yup.string().nullable(),
      batteryCapacity: Yup.string().required('Vui lòng nhập dung lượng pin'),
      connectorType: Yup.string().nullable(),
    }),
  },

  // MARK: ---- DATA ----
  Data: {
    // ---- RFID ----
    chargeRfidStatusOptions: [
      { value: ChargeConstants.RFIDCardStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.RFIDCardStatus.BLOCKED, name: 'Bị khóa' },
    ],
    // ---- TRAM SAC ----
    chargeStationStatusOptions: [
      { value: ChargeConstants.ChargeStationStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.ChargeStationStatus.MAINTAINING, name: 'Đang bảo trì' },
      { value: ChargeConstants.ChargeStationStatus.PENDING, name: 'Đang lắp đặt' },
      { value: ChargeConstants.ChargeStationStatus.DISCONNECTED, name: 'Mất kết nối' },
      { value: ChargeConstants.ChargeStationStatus.HIDDEN, name: 'Đang ẩn' },
      { value: ChargeConstants.ChargeStationStatus.STOPPED, name: 'Ngừng hoạt động' },
      { value: ChargeConstants.ChargeStationStatus.DELETED, name: 'Đã xóa' },
    ],
    // ---- TRU SAC ----
    chargePointStatusOptions: [
      { value: ChargeConstants.ChargePointStatus.AVAILABLE, name: 'Sẵn sàng' },
      { value: ChargeConstants.ChargePointStatus.BUSY, name: 'Đang bận' },
      { value: ChargeConstants.ChargePointStatus.FAULT, name: 'Lỗi' },
      { value: ChargeConstants.ChargePointStatus.MAINTAINING, name: 'Bảo trì' },
      { value: ChargeConstants.ChargePointStatus.DISCONNECTED, name: 'Mất kết nối' },
      { value: ChargeConstants.ChargePointStatus.DISABLE, name: 'Vô hiệu hóa' },
      { value: ChargeConstants.ChargePointStatus.RESERVED, name: 'Đang đặt chỗ' },
    ],
    chargePointTypeOptions: [
      { value: ChargeConstants.ChargePointType.AC, name: 'AC' },
      { value: ChargeConstants.ChargePointType.DC, name: 'DC' },
    ],
    chargePointNumberConnectorOptions: [
      { value: 1, name: '1 súng sạc' },
      { value: 2, name: '2 súng sạc' },
      { value: 3, name: '3 súng sạc' },
      { value: 4, name: '4 súng sạc' },
      { value: 5, name: '5 súng sạc' },
      { value: 6, name: '6 súng sạc' },
      { value: 7, name: '7 súng sạc' },
      { value: 8, name: '8 súng sạc' },
      { value: 9, name: '9 súng sạc' },
      { value: 10, name: '10 súng sạc' },
    ],
    // ---- VOI SAC ----
    chargeConnectorStatusOptions: [
      { value: ChargeConstants.ChargeConnectorStatus.AVAILABLE, name: 'Sẵn sàng' },
      { value: ChargeConstants.ChargeConnectorStatus.PREPARING, name: 'Đang chuẩn bị' },
      { value: ChargeConstants.ChargeConnectorStatus.CHARGING, name: 'Đang sạc' },
      { value: ChargeConstants.ChargeConnectorStatus.SUSPENDED, name: 'Đang tạm dừng' },
      { value: ChargeConstants.ChargeConnectorStatus.FINISHING, name: 'Đang kết thúc' },
      { value: ChargeConstants.ChargeConnectorStatus.RESERVED, name: 'Đang đặt chỗ' },
    ],
    chargeConnectorTypeOptions: [
      {
        value: ChargeConstants.ChargeConnectorType.CCS2,
        name: 'CCS2',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`ccs2Connector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.AC,
        name: 'Smart AC Socket',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`acConnector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.J1772,
        name: 'J1772 - Type 1',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`j1772Connector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.Mennekes,
        name: 'Mennekes - Type 2',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`mennekesConnector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.GB_T,
        name: 'GB/T',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`gbtPlug`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.CHAdeMO,
        name: 'CHAdeMO',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`chademoConnector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.CCS1,
        name: 'CCS1',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`ccs1Connector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.Tesla,
        name: 'Tesla',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`teslaConnector`]}
          />
        ),
      },
    ],
    // ---- THONG BAO ----
    messageLogTypeOptions: [
      { value: ChargeConstants.MessageLogType.INFO, name: 'Thông tin' },
      { value: ChargeConstants.MessageLogType.NOTICE, name: 'Thông báo' },
      { value: ChargeConstants.MessageLogType.WARNING, name: 'Cảnh báo' },
      { value: ChargeConstants.MessageLogType.ERROR, name: 'Lỗi' },
    ],
    vehicleChargingModeOptions: [
      { value: ChargeConstants.VehicleChargingMode.NORMAL, name: 'Sạc thông thường' },
      { value: ChargeConstants.VehicleChargingMode.SMART, name: 'Sạc nhận diện xe (Plug & Charge)' },
    ],
    vehicleTypeOptions: AppConfigs.env.hideBike == 1
      ? [
        { value: ChargeConstants.VehicleType.CAR, name: 'Ô tô' },
      ]
      : [
        { value: ChargeConstants.VehicleType.CAR, name: 'Ô tô' },
        { value: ChargeConstants.VehicleType.BIKE, name: 'Xe máy' },
      ],
    networkOperatorOptions: [
      { value: 'VIETTEL', name: 'Viettel' },
      { value: 'VINAPHONE', name: 'Vinaphone' },
    ],
    chargeStationPricingModeOptions: [
      { value: ChargeConstants.ChargePricingMode.FLAT, name: 'Cố định' },
      { value: ChargeConstants.ChargePricingMode.HOURS, name: 'Theo khung giờ' },
      { value: ChargeConstants.ChargePricingMode.TIERED, name: 'Theo bậc thang' },
    ],
    chargePointPricingModeOptions: [
      { value: ChargeConstants.ChargePricingMode.FLAT, name: 'Cố định' },
      { value: ChargeConstants.ChargePricingMode.HOURS, name: 'Theo khung giờ' },
    ],
    chargePricingStationModeOptions: [
      { value: ChargeConstants.ChargePricingMode.FLAT, name: 'Đồng giá' },
      { value: ChargeConstants.ChargePricingMode.HOURS, name: 'Theo khung giờ' },
      { value: ChargeConstants.ChargePricingMode.TIERED, name: 'Theo bậc thang' },
    ],
    notificationCategoryOptions: [
      { value: ChargeConstants.NotificationCategory.BUSINESS, name: 'Kinh doanh' },
      { value: ChargeConstants.NotificationCategory.OPERATION, name: 'Vận hành' },
      { value: ChargeConstants.NotificationCategory.PROMOTION, name: 'Khuyến mãi' },
      { value: ChargeConstants.NotificationCategory.CHARGE, name: 'Sạc xe & Giao dịch' },
      { value: ChargeConstants.NotificationCategory.OTHER, name: 'Khác' },
      { value: ChargeConstants.NotificationCategory.EVG, name: 'EVG' },
    ],
    // ---- PHIEN SAC ----
    chargeTransactionStatusOptions: [
      { value: ChargeConstants.ChargeTransactionStatus.INITIATING, name: 'Khởi tạo' },
      { value: ChargeConstants.ChargeTransactionStatus.PREPARING, name: 'Chuẩn bị' },
      { value: ChargeConstants.ChargeTransactionStatus.CHARGING, name: 'Đang sạc' },
      { value: ChargeConstants.ChargeTransactionStatus.FINISHING, name: 'Đang kết thúc' },
      { value: ChargeConstants.ChargeTransactionStatus.FINISHED, name: 'Đã kết thúc' },
      { value: ChargeConstants.ChargeTransactionStatus.CANCELLED, name: 'Đã hủy' },
      { value: ChargeConstants.ChargeTransactionStatus.FAILED, name: 'Lỗi' },
      { value: ChargeConstants.ChargeTransactionStatus.RESERVED, name: 'Đang đặt chỗ' },
    ],
    // ---- XE ----
    vehicleStatusOptions: [
      { value: ChargeConstants.VehicleStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.VehicleStatus.DELETED, name: 'Đã xóa' },
      { value: ChargeConstants.VehicleStatus.PENDING, name: 'Chờ xác nhận' },
    ],
    // ---- MA DINH DANH ----
    chargeIdentifierStatusOptions: [
      { value: ChargeConstants.ChargeIdentifierStatus.ACTIVE, name: 'Được phép sạc' },
      { value: ChargeConstants.ChargeIdentifierStatus.INACTIVE, name: 'Bị chặn' },
    ],
    // ---- RFID ----
    rfidCardStatusOptions: [
      { value: ChargeConstants.RFIDCardStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.RFIDCardStatus.BLOCKED, name: 'Bị khóa' },
    ],
    // ---- KHACH HANG ----
    chargeDriverStatusOptions: [
      { value: ChargeConstants.ChargeDriverStatus.REGISTERED, name: 'Chờ kích hoạt' },
      { value: ChargeConstants.ChargeDriverStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.ChargeDriverStatus.SUSPENDED, name: 'Ngừng hoạt động' },
      { value: ChargeConstants.ChargeDriverStatus.DELETED, name: 'Đã xóa' },
    ],
    chargeDriverPricingTypeOptions: [
      { value: ChargeConstants.ChargeDriverPricingType.STANDARD, name: 'Tiêu chuẩn' },
      { value: ChargeConstants.ChargeDriverPricingType.DISCOUNT, name: 'Ưu đãi' },
      { value: ChargeConstants.ChargeDriverPricingType.FREE, name: 'Miễn phí' },
    ],
    // ---- PAYMENT ----
    chargePaymentStatusOptions: [
      { value: ChargeConstants.ChargePaymentStatus.PENDING, name: 'Chờ xác nhận' },
      { value: ChargeConstants.ChargePaymentStatus.COMPLETED, name: 'Đã thanh toán' },
      { value: ChargeConstants.ChargePaymentStatus.FAILED, name: 'Thất bại' },
    ],
    chargePaymentMethodOptions: [
      { value: ChargeConstants.ChargePaymentMethod.WALLET, name: 'Ví điện tử' },
      { value: ChargeConstants.ChargePaymentMethod.CASH, name: 'Tiền mặt' },
      { value: ChargeConstants.ChargePaymentMethod.QR, name: 'Mã QR' },
      { value: ChargeConstants.ChargePaymentMethod.VNPAY, name: 'VNPAY QR' },
      { value: ChargeConstants.ChargePaymentMethod.MOMO, name: 'Ví MoMo' },
      { value: ChargeConstants.ChargePaymentMethod.INTERNAL, name: 'Nạp nội bộ' },
    ],
    chargePaymentTypeOptions: [
      { value: ChargeConstants.ChargePaymentMethod.INTERNAL, name: 'Nạp tiền' },
      { value: ChargeConstants.ChargePaymentMethod.WALLET, name: 'Chi tiền' },
      { value: ChargeConstants.ChargePaymentMethod.REFUND, name: 'Hoàn tiền' },
    ],
    // ---- WALLET TRANSACTION ----
    walletTransactionStatusOptions: [
      { value: ChargeConstants.WalletTransactionStatus.PENDING, name: 'Chờ thanh toán' },
      { value: ChargeConstants.WalletTransactionStatus.COMPLETED, name: 'Hoàn thành' },
      { value: ChargeConstants.WalletTransactionStatus.CANCELLED, name: 'Đã hủy' },
      { value: ChargeConstants.WalletTransactionStatus.FAILED, name: 'Thất bại' },
    ],
    driverTopUpPaymentMethodOptions: [
      { value: 'NAPAS', name: 'Napas' },
      { value: ChargeConstants.ChargePaymentMethod.MOMO, name: 'MoMo' },
      { value: ChargeConstants.ChargePaymentMethod.VNPAY, name: 'VNPAY' },
      { value: ChargeConstants.ChargePaymentMethod.INTERNAL, name: 'Nạp nội bộ' },
    ],
    // ---- DASHBOARD ----
    dashboardRevenueTypeOptions: [
      // { value: ChargeConstants.DashboardRevenueType.GROUP, name: 'Bán gói đầu tư HTKD' },
      // { value: ChargeConstants.DashboardRevenueType.CHARGEPOINT, name: 'Bán trụ sạc' },
      { value: ChargeConstants.DashboardRevenueType.INVESTOR, name: 'Bán nhượng quyền' },
      { value: ChargeConstants.DashboardRevenueType.GROUP, name: 'Liên kết' },
    ],
    saleDashboardRevenueTypeOptions: [
      { value: ChargeConstants.DashboardRevenueType.INVESTOR, name: 'Bán nhượng quyền' },
      { value: ChargeConstants.DashboardRevenueType.COINVESTOR, name: 'Bán liên kết' },
    ],
    // ---- TUTORIAL ----
    tutorialObjectOptions: [
      { value: ChargeConstants.TutorialObject.DRIVER, name: 'Tài xế' },
      { value: ChargeConstants.TutorialObject.AGENCY, name: 'Đối tác' },
    ],
    tutorialStatusOptions: [
      { value: ChargeConstants.TutorialStatus.NORMAL, name: 'Hoạt động' },
      { value: ChargeConstants.TutorialStatus.DELETED, name: 'Đang ẩn' },
    ],
    // ---- INVENTORY ----
    inventoryUnitOptions: [
      { value: 'Bộ', name: 'Bộ' },
      { value: 'Cái', name: 'Cái' },
      { value: 'Chiếc', name: 'Chiếc' },
      { value: 'Gói', name: 'Gói' },
      { value: 'Mét', name: 'Mét' },
      { value: 'Thiết bị', name: 'Thiết bị' },
      { value: 'Tủ', name: 'Tủ' },
      { value: 'Dịch vụ', name: 'Dịch vụ' },
      { value: 'Hạng mục', name: 'Hạng mục' },
      { value: 'Lần', name: 'Lần' },
      { value: 'Yêu cầu', name: 'Yêu cầu' },
    ],
    // ---- ELECTRICITY PAYER ----
    electricityPayerOptions: (agencyRole) => [
      { value: '1', name: agencyRole === 'INVESTOR' ? 'NĐT nhượng quyền' : 'Chủ mặt bằng' },
      { value: '0', name: 'Nhà điều hành' },
    ],
    // ---- NOTIFICATION ----
    notificationStatusOptions: [
      { value: '1', name: 'Đã gửi' },
      { value: '0', name: 'Đã lên lịch' },
    ],
  },

  // MARK: ---- API ----
  API: {
    // MARK: ---- TRAM SAC ----
    // lay danh sach tram sac
    requestGetChargeStationList: async (params) => {
      const url = '/cs';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, chargeStations, total } = response;
        if (result === 'success') {
          return { chargeStations, total };
        }
        return { chargeStations: [], total: 0 };
      } catch (error) {
        return { chargeStations: [], total: 0 };
      }
    },
    // lay chi tiet tram sac
    getChargeStationDetail: async (chargeStationId) => {
      const url = `/cs/${chargeStationId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, chargeStation } = response;
        if (result === 'success') {
          return chargeStation;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // them tram sac
    requestAddChargeStation: async (data) => {
      const url = '/cs/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, station, reason } = response;
        if (result === 'success') {
          return station;
        }
        return reason;
      } catch (error) {
        throw error?.response?.data?.reason || 'Thêm trạm sạc thất bại';
      }
      return false;
    },
    // cap nhat tram sac
    requestUpdateChargeStation: async (chargeStationId, data) => {
      const url = `/cs/${chargeStationId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        throw error?.response?.data?.reason || 'Cập nhật trạm sạc thất bại';
      }
      return false;
    },
    // xoa tram sac
    requestDeleteChargeStation: async (chargeStationId) => {
      const url = `/cs/${chargeStationId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        throw error?.response?.data?.reason || 'Xóa trạm sạc thất bại';
      }
      return false;
    },

    // MARK: ---- TRU SAC ----
    // lay danh sach tru sac
    requestGetChargePointList: async (params) => {
      const url = '/cp';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, chargePoints, total } = response;
        if (result === 'success') {
          return { chargePoints, total };
        }
        return { chargePoints: [], total: 0 };
      } catch (error) {
        return { chargePoints: [], total: 0 };
      }
    },
    // lay chi tiet tru sac
    requestGetChargePointDetail: async (chargePointId) => {
      const url = `/cp/${chargePointId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, chargePoint } = response;
        if (result === 'success') {
          return chargePoint;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // them tru sac
    requestAddChargePoint: async (data) => {
      const url = '/cp/create';
      try {
        const response = await axiosClient.post(url, data);
        return response;
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm trụ sạc thất bại';
      }
    },
    // cap nhat tru sac
    requestUpdateChargePoint: async (chargePointId, data) => {
      const url = `/cp/${chargePointId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result, reason } = response || {};
        if (result === 'success') {
          return { success: true, reason: null, data: response };
        }
        return {
          success: false,
          reason: reason || 'Cập nhật trụ sạc thất bại',
          data: response,
        };
      } catch (error) {
        const reason = error?.response?.data?.reason || 'Cập nhật trụ sạc thất bại';
        return { success: false, reason };
      }
    },
    // xoa tru sac
    requestDeleteChargePoint: async (chargePointId) => {
      const url = `/cp/${chargePointId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa trụ sạc thất bại';
      }
    },
    // khoi dong lai tru sac
    requestRestartChargePoint: async (chargePointId) => {
      const url = '/cp/rebootCharger';
      try {
        const response = await axiosClient.post(url, { pointId: chargePointId });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Khởi động lại trụ sạc thất bại';
      }
    },
    // lay lich su cap nhat firmware
    requestGetFirmwareHistory: async (chargePointId) => {
      const url = `/cp/${chargePointId}/firmwareHistory`;
      try {
        const response = await axiosClient.get(url);
        return response;
      } catch (error) {
        return null;
      }
    },
    // cap nhat firmware tru sac
    requestUpdateFirmware: async (chargePointId, firmwareUrl) => {
      const url = '/cp/updateFirmware';
      try {
        const response = await axiosClient.post(url, {
          pointId: chargePointId,
          firmwareUrl: Utils.getFullUrl(firmwareUrl),
        });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật firmware thất bại';
      }
    },
    // vo hieu hoa / kich hoat lai tru sac
    requestChangeAvailabilityChargePoint: async (chargePointId, availability) => {
      const url = '/cp/changeAvailability';
      try {
        const response = await axiosClient.post(url, { pointId: chargePointId, availability });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thao tác thất bại';
      }
    },
    // thiet lap gioi han cong suat cua tru sac
    requestSetChargePointPowerLimit: async (chargePointId, powerLimit) => {
      const url = '/cp/setPowerLimit';
      try {
        const response = await axiosClient.post(url, { pointId: chargePointId, powerLimit });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thiết lập công suất trụ sạc thất bại';
      }
    },

    // MARK: ---- VOI SAC ----
    // tao voi sac
    requestCreateChargeConnector: async (pointId, data) => {
      const url = `/cp/${pointId}/createConnector`;
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm súng sạc thất bại';
      }
    },
    // xoa voi sac
    requestDeleteChargeConnector: async (pointId, connectorId) => {
      const url = `/cp/${pointId}/connector/${connectorId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa súng sạc thất bại';
      }
    },
    // cap nhat thong tin voi sac
    requestUpdateChargeConnector: async (pointId, connectorId, data) => {
      const url = `/cp/${pointId}/connector/${connectorId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật súng sạc thất bại';
      }
    },
    // dung súng sạc
    requestStopChargeConnector: async (pointId, connectorNumber) => {
      const url = `/cp/stopCharger`;
      try {
        const response = await axiosClient.post(url, {
          pointId,
          connectorNumber,
        });
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Dừng súng sạc thất bại';
      }
    },
    // kich hoat sac
    requestActivateCharger: async (params) => {
      const url = '/cp/activateChargerCashier';
      try {
        const response = await axiosClient.post(url, params);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Kích hoạt súng sạc thất bại';
      }
    },

    // MARK: ---- THIET BI ----
    // lay danh sach thiet bi
    requestGetChargeInventoryList: async (params) => {
      const url = '/inventory/item/';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, items, total } = response;
        if (result === 'success') {
          return { items, total };
        }
        return { items: [], total: 0 };
      } catch (error) {
        return { items: [], total: 0 };
      }
    },
    // lay chi tiet thiet bi
    requestGetChargeInventoryDetail: async (categoryId) => {
      const url = `/inventory/item/${categoryId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, category } = response;
        if (result === 'success') {
          return category;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao thiet bi
    requestCreateChargeInventory: async (data) => {
      const url = '/inventory/item/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Tạo thiết bị thất bại';
      }
    },
    // cap nhat thiet bi
    requestUpdateChargeInventory: async (inventoryId, data) => {
      const url = `/inventory/item/${inventoryId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật thiết bị thất bại';
      }
    },
    // xoa thiet bi
    requestDeleteChargeInventory: async (inventoryId) => {
      const url = `/inventory/item/${inventoryId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa thiết bị thất bại';
      }
    },

    // MARK: ---- DANH MUC THIET BI ----
    // lay danh sach danh muc thiet bi
    requestGetChargeInventoryCategoryList: async (params) => {
      const url = '/inventory/category/';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, categories, total } = response;
        if (result === 'success') {
          return { categories, total };
        }
        return { categories: [], total: 0 };
      } catch (error) {
        return { categories: [], total: 0 };
      }
    },
    // lay chi tiet danh muc thiet bi
    requestGetChargeInventoryCategoryDetail: async (categoryId) => {
      const url = `/inventory/category/${categoryId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, category } = response;
        if (result === 'success') {
          return category;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao danh muc thiet bi
    requestCreateChargeInventoryCategory: async (data) => {
      const url = '/inventory/category/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Tạo danh mục thiết bị thất bại';
      }
    },
    // cap nhat danh muc thiet bi
    requestUpdateChargeInventoryCategory: async (categoryId, data) => {
      const url = `/inventory/category/${categoryId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật danh mục thiết bị thất bại';
      }
    },
    // xoa danh muc thiet bi
    requestDeleteChargeInventoryCategory: async (categoryId) => {
      const url = `/inventory/category/${categoryId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa danh mục thiết bị thất bại';
      }
    },

    // MARK: ---- DINH GIA ----
    // lay danh sach dinh gia
    requestGetChargePricingList: async (params) => {
      const url = '/pricing';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, pricings, total } = response;
        if (result === 'success') {
          return { pricings, total };
        }
        return { pricings: [], total: 0 };
      } catch (error) {
        return { pricings: [], total: 0 };
      }
    },
    // lay chi tiet dinh gia
    requestGetChargePricingDetail: async (pricingId) => {
      const url = `/pricing/${pricingId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, pricing } = response;
        if (result === 'success') {
          return pricing;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao dinh gia
    requestCreateChargePricing: async (data) => {
      const url = '/pricing/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Tạo định giá thất bại';
      }
    },
    // cap nhat dinh gia
    requestUpdateChargePricing: async (pricingId, data) => {
      const url = `/pricing/${pricingId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật định giá thất bại';
      }
    },
    // xoa dinh gia
    requestDeleteChargePricing: async (pricingId) => {
      const url = `/pricing/${pricingId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa định giá thất bại';
      }
    },

    // MARK: ---- THONG BAO ----
    // lay danh sach thong bao
    getMessageLogList: async (chargeStationId, params) => {
      const url = '/message';
      const requestParams = { ...params };
      if (chargeStationId) {
        requestParams.stationId = chargeStationId;
      }
      try {
        const response = await axiosClient.get(url, {
          params: requestParams,
        });
        const { result, messages, total } = response;
        if (result === 'success') {
          return { messages, total };
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },

    // MARK: ---- DOI TAC SAC ----
    requestGetChargeIdentityPartnerList: async (params = {}) => {
      const url = '/vehicleIdentityPartner';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, vehicleIdentityPartners, total } = response;
        if (result === 'success') {
          return { partners: vehicleIdentityPartners, total };
        }
        return { partners: [], total: 0 };
      } catch (error) {
        return { partners: [], total: 0 };
      }
    },
    requestAddChargeIdentityPartner: async (data) => {
      const url = '/vehicleIdentityPartner/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm đối tác sạc thất bại';
      }
    },
    requestUpdateChargeIdentityPartner: async (partnerId, data) => {
      const url = `/vehicleIdentityPartner/${partnerId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật thông tin đối tác sạc thất bại';
      }
    },
    requestDeleteChargeIdentityPartner: async (partnerId) => {
      const url = `/vehicleIdentityPartner/${partnerId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa đối tác sạc thất bại';
      }
    },

    // MARK: ---- HANG SAN XUAT TRU SAC ----
    // lay danh sach hang san xuat tru sac
    requestGetChargeBrandList: async (params = {}) => {
      const url = '/charger/brand';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, brands, total } = response;
        if (result === 'success') {
          return { brands, total };
        }
        return { brands: [], total: 0 };
      } catch (error) {
        return { brands: [], total: 0 };
      }
    },
    // xoa hang san xuat tru sac
    requestDeleteChargeBrand: async (brandId) => {
      const url = `/charger/brand/${brandId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa hãng sản xuất trụ sạc thất bại';
      }
    },
    // them hang san xuat tru sac
    requestAddChargeBrand: async (data) => {
      const url = '/charger/brand/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm hãng sản xuất trụ sạc thất bại';
      }
    },
    // cap nhat hang san xuat tru sac
    requestUpdateChargeBrand: async (brandId, data) => {
      const url = `/charger/brand/${brandId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật hãng sản xuất trụ sạc thất bại';
      }
    },

    // MARK: ---- MODEL TRU SAC ----
    // lay danh sach model tru sac
    requestGetChargeModelList: async (params) => {
      const url = `/charger/model`;
      try {
        const response = await axiosClient.get(url, { params });
        const { result, models, total } = response;
        if (result === 'success') {
          return { models, total };
        }
        return { models: [], total: 0 };
      } catch (error) {
        return { models: [], total: 0 };
      }
    },
    // xoa model tru sac
    requestDeleteChargeModel: async (modelId) => {
      const url = `/charger/model/${modelId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa model trụ sạc thất bại';
      }
    },
    // them model tru sac
    requestAddChargeModel: async (data) => {
      const url = '/charger/model/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model trụ sạc thất bại';
      }
    },
    // cap nhat model tru sac
    requestUpdateChargeModel: async (modelId, data) => {
      const url = `/charger/model/${modelId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật model trụ sạc thất bại';
      }
    }, // them model tru sac
    requestAddChargeModel: async (data) => {
      const url = '/charger/model/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model trụ sạc thất bại';
      }
    },
    // cap nhat model tru sac
    requestUpdateChargeModel: async (modelId, data) => {
      const url = `/charger/model/${modelId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật model trụ sạc thất bại';
      }
    },

    // MARK: ---- TAI KHOAN DIEN LUC ----
    // them tai khoan dien luc
    requestAddEnergyAccount: async (data) => {
      const url = '/energyAccount/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm tài khoản điện lực thất bại';
      }
    },
    // cap nhat tai khoan dien luc
    requestUpdateEnergyAccount: async (accountId, data) => {
      const url = `/energyAccount/${accountId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật tài khoản điện lực thất bại';
      }
    },
    // xoa tai khoan dien luc
    requestDeleteEnergyAccount: async (accountId) => {
      const url = `/energyAccount/${accountId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa tài khoản điện lực thất bại';
      }
    },

    // MARK: ---- PAYMENT ----
    Payment: {
      // lay danh sach thanh toan
      requestGetPaymentList: async (params) => {
        const url = '/payment';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, payments, total } = response;
          if (result === 'success') {
            return { payments, total };
          }
          return { payments: [], total: 0 };
        } catch (error) {
          return { payments: [], total: 0 };
        }
      },
    },

    // MARK: ---- WALLET TRANSACTION ----
    WalletTransaction: {
      // lay danh sach giao dich vi
      requestGetWalletTransactionList: async (params) => {
        const url = '/wallet/transactions';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, walletTransactions, total } = response;
          if (result === 'success') {
            return { walletTransactions, total };
          }
          return { walletTransactions: [], total: 0 };
        } catch (error) {
          return { walletTransactions: [], total: 0 };
        }
      },
    },

    // MARK: ---- HANG XE ----
    VehicleBrand: {
      // lay danh sach hang xe
      requestGetVehicleBrandList: async (params = {}) => {
        const url = '/brand';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, brands, total } = response;
          if (result === 'success') {
            return { brands, total };
          }
          return { brands: [], total: 0 };
        } catch (error) {
          return { brands: [], total: 0 };
        }
      },
    },

    // MARK: ---- DONG XE ----
    VehicleModel: {
      // lay danh sach dong xe
      requestGetVehicleModelList: async (brandId, params = {}) => {
        const url = `/brand/${brandId}/model`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, models, total } = response;
          if (result === 'success') {
            return { models, total };
          }
          return { models: [], total: 0 };
        } catch (error) {
          return { models: [], total: 0 };
        }
      },
    },

    // MARK: ---- PHIEN SAC ----
    ChargeTransaction: {
      // lay danh sach phien sac
      requestGetChargeTransactionList: async (params) => {
        const url = '/ct';
        try {
          const response = await axiosClient.get(url, {
            params: {
              exclusionZeroCost: false,
              ...params,
            },
          });
          const { result, chargeTransactions, total } = response;
          if (result === 'success') {
            return { chargeTransactions, total };
          }
          return { chargeTransactions: [], total: 0 };
        } catch (error) {
          return { chargeTransactions: [], total: 0 };
        }
      },
      // xuat hoa don phien sac
      requestCreateInvoiceChargeTransaction: async (data) => {
        const url = '/ct/createInvoice';
        try {
          const response = await axiosClient.post(url, data);
          const { result, invoiceSerial } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason;
        }
      },
      // huy dat cho
      requestCancelReservedTransaction: async (data) => {
        const url = '/ct/cancelReservation'
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason;
        }
      }
    },

    // MARK: ---- HANG XE ----
    ChargeVehicleBrand: {
      // lay danh sach hang xe
      requestGetChargeVehicleBrandList: async (params = {}) => {
        const url = '/brand';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, brands, total } = response;
          if (result === 'success') {
            return { brands, total };
          }
          return { brands: [], total: 0 };
        } catch (error) {
          return { brands: [], total: 0 };
        }
      },
      // them hang xe
      requestAddChargeVehicleBrand: async (data) => {
        const url = '/brand/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm hãng xe thất bại';
        }
      },
      // cap nhat hang xe
      requestUpdateChargeVehicleBrand: async (brandId, data) => {
        const url = `/brand/${brandId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật hãng xe thất bại';
        }
      },
      // xoa hang xe
      requestDeleteChargeVehicleBrand: async (brandId) => {
        const url = `/brand/${brandId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa hãng xe thất bại';
        }
      },
    },

    // MARK: ---- DONG XE ----
    ChargeVehicleModel: {
      // lay danh sach dong xe
      requestGetChargeVehicleModelList: async (vehicleBrandId, params = {}) => {
        const url = `/brand/${vehicleBrandId}/model`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, models, total } = response;
          if (result === 'success') {
            return { models, total };
          }
          return { models: [], total: 0 };
        } catch (error) {
          return { models: [], total: 0 };
        }
      },
      // them dong xe
      requestAddChargeVehicleModel: async (vehicleBrandId, data) => {
        const url = `/brand/${vehicleBrandId}/model/create`;
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm model xe thất bại';
        }
      },
      // cap nhat dong xe
      requestUpdateChargeVehicleModel: async (vehicleBrandId, vehicleModelId, data) => {
        const url = `/brand/${vehicleBrandId}/model/${vehicleModelId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật model xe thất bại';
        }
      },
      // xoa dong xe
      requestDeleteChargeVehicleModel: async (vehicleBrandId, vehicleModelId) => {
        const url = `/brand/${vehicleBrandId}/model/${vehicleModelId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa model xe thất bại';
        }
      },
    },

    // MARK: ---- XE ----
    Vehicle: {
      // lay danh sach xe
      requestGetVehicleList: async (params = {}) => {
        const url = '/vehicle';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, vehicles, total } = response;
          if (result === 'success') {
            return { vehicles, total };
          }
          return { vehicles: [], total: 0 };
        } catch (error) {
          return { vehicles: [], total: 0 };
        }
      },
      // lay chi tiet xe
      requestGetVehicleDetail: async (vehicleId) => {
        const url = `/vehicle/${vehicleId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, vehicle } = response;
          if (result === 'success') {
            return vehicle;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them xe
      requestAddVehicle: async (data) => {
        const url = '/vehicle/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm xe thất bại';
        }
      },
      // cap nhat xe
      requestUpdateVehicle: async (vehicleId, data) => {
        const url = `/vehicle/${vehicleId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật xe thất bại';
        }
      },
      // requestUpdateAutoChargeConfig: async (vehicleId, autoCharge) => {
      //   const url = '/autoChargeConfig';
      //   try {
      //     const response = await axiosClient.post(url, {
      //       vehicleId,
      //       autoCharge,
      //     });
      //     const { result } = response;
      //     return result === 'success';
      //   } catch (error) {
      //     return error?.response?.data?.reason || 'Cập nhật chế độ sạc thất bại';
      //   }
      // },
      // xoa xe
      requestDeleteVehicle: async (vehicleId) => {
        const url = `/vehicle/${vehicleId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa xe thất bại';
        }
      },
    },
    // MARK: ---- SYSTEM LOG ----
    SystemLog: {
      // lay danh sach thong bao he thong
      requestGetSystemLogList: async (params) => {
        const url = '/message';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, messages, total } = response;
          if (result === 'success') {
            return { messages, total };
          }
          return { messages: [], total: 0 };
        } catch (error) {
          return { messages: [], total: 0 };
        }
      },
    },
    // MARK: ---- DRIVER ----
    Driver: {
      // lay danh sach khach hang
      requestGetDriverList: async (params = {}) => {
        const url = '/driver';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, drivers, total } = response;
          if (result === 'success') {
            return { drivers, total };
          }
          return { drivers: [], total: 0 };
        } catch (error) {
          return { drivers: [], total: 0 };
        }
      },
      // lay chi tiet khach hang
      requestGetDriverDetail: async (driverId) => {
        const url = `/driver/${driverId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, driver } = response;
          if (result === 'success') {
            return driver;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them khach hang
      requestAddDriver: async (data) => {
        const url = '/driver/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm mới khách hàng thất bại';
        }
      },
      // cap nhat khach hang
      requestUpdateDriver: async (driverId, data) => {
        const url = `/driver/${driverId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Chỉnh sửa thông tin khách hàng thất bại';
        }
      },
      // xoa khach hang
      requestDeleteDriver: async (driverId) => {
        const url = `/driver/${driverId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa khách hàng thất bại';
        }
      },
      // nap tien cho khach hang
      requestTopUpDriver: async (driverId, amount) => {
        const url = '/driver/topup';
        try {
          const response = await axiosClient.post(url, {
            driverId,
            amount,
            paymentMethod: ChargeConstants.ChargePaymentMethod.INTERNAL,
          });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Nạp tiền thất bại';
        }
      },
      // lay lich su giao dich cua khach hang
      requestGetDriverTransactionHistory: async (driverId, params = {}) => {
        const url = `/driver/${driverId}/transactions`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, paymentCount, topupCount, transactionCount, payments, topups, transactions } = response;
          if (result === 'success') {
            return { paymentCount, topupCount, transactionCount, payments, topups, transactions };
          }
          return { paymentCount: 0, topupCount: 0, transactionCount: 0, payments: [], topups: [], transactions: [] };
        } catch (error) {
          return { paymentCount: 0, topupCount: 0, transactionCount: 0, payments: [], topups: [], transactions: [] };
        }
      },
      // lay lich su sac xe cua khach hang
      requestGetDriverChargeSessions: async (driverId, params = {}) => {
        const url = `/driver/${driverId}/chargeSessions`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, chargeSessions, total } = response;
          if (result === 'success') {
            return { chargeSessions, total };
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || 'Lấy lịch sử sạc xe thất bại';
        }
      },
    },

    // MARK: ---- RFID ----
    RFID: {
      // lay danh sach the RFID
      requestGetRFIDCardList: async (params = {}) => {
        const url = '/rfid';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, chargeRFIDs, total } = response;
          if (result === 'success') {
            return { chargeRFIDs, total };
          }
          return { chargeRFIDs: [], total: 0 };
        } catch (error) {
          return { chargeRFIDs: [], total: 0 };
        }
      },
      // lay chi tiet the RFID
      requestGetRFIDCardDetail: async (rfidCardId) => {
        const url = `/rfid/${rfidCardId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, chargeRFID } = response;
          if (result === 'success') {
            return chargeRFID;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them the RFID
      requestAddRFIDCard: async (data) => {
        const url = '/rfid/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result, reason } = response;
          if (result === 'success') return true;
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm thẻ RFID thất bại';
        }
      },
      // cap nhat the RFID
      requestUpdateRFIDCard: async (rfidCardId, data) => {
        const url = `/rfid/${rfidCardId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật thẻ RFID thất bại';
        }
      },
      // xoa the RFID
      requestDeleteRFIDCard: async (rfidCardId) => {
        const url = `/rfid/${rfidCardId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa thẻ RFID thất bại';
        }
      },
    },

    // MARK: ---- MA DINH DANH (EVCC) ----
    Identifier: {
      requestGetIdentifierList: async (params = {}) => {
        const url = '/vehicleIdentity';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, vehicleIdentities, total } = response;
          if (result === 'success') {
            return { vehicleIdentities, total };
          }
          return { vehicleIdentities: [], total: 0 };
        } catch (error) {
          return { vehicleIdentities: [], total: 0 };
        }
      },
      requestGetVehicleIdentityDetail: async (vehicleIdentityId) => {
        const url = `/vehicleIdentity/${vehicleIdentityId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, vehicleIdentity } = response;
          if (result === 'success') {
            return vehicleIdentity;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      requestGetIdentifierDetail: async (identifierId) => {
        const url = `/evcc/${identifierId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, evcc } = response;
          if (result === 'success') {
            return evcc;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      requestAddIdentifier: async (data) => {
        const url = 'vehicleIdentity/create';
        try {
          const response = await axiosClient.post(url, {
            vehicleIdentityPartnerId: data.vehicleIdentityPartnerId,
            code: data.code,
            vehicleId: data.vehicleId ?? null,
          });
          const { result, reason } = response;
          if (result === 'success') return true;
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm mã định danh thất bại';
        }
      },
      requestUpdateIdentifier: async (identifierId, data) => {
        const url = `/vehicleIdentity/${identifierId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Gán mã định danh thất bại';
        }
      },
      requestDeleteIdentifier: async (identifierId) => {
        const url = `/vehicleIdentity/${identifierId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa mã định danh thất bại';
        }
      },
      requestUpdateIdentifierStatus: async (ids, status, defaultErrorMessage) => {
        const url = '/vehicleIdentity/updateStatus';
        try {
          const response = await axiosClient.put(url, { vehicleIdentityIds: ids, status });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || defaultErrorMessage;
        }
      },
      requestAllowBatchIdentifiers: async (ids) => {
        return ChargeHelper.API.Identifier.requestUpdateIdentifierStatus(
          ids,
          ChargeConstants.ChargeIdentifierStatus.ACTIVE,
          'Cấp phép sạc cho mã định danh thất bại'
        );
      },
      requestBlockBatchIdentifiers: async (ids) => {
        return ChargeHelper.API.Identifier.requestUpdateIdentifierStatus(
          ids,
          ChargeConstants.ChargeIdentifierStatus.INACTIVE,
          'Chặn sạc mã định danh thất bại'
        );
      },
      requestUploadIdentifierExcel: async (vehicleIdentityPartnerId, file) => {
        const url = '/vehicleIdentity/import';
        const buildInvalidResult = (data) => {
          if (data?.excelBase64) {
            return { invalid: true, excelBase64: data.excelBase64, reason: data.reason };
          }
          return null;
        };
        try {
          const formData = new FormData();
          formData.append('file', file);
          if (vehicleIdentityPartnerId) {
            formData.append('vehicleIdentityPartnerId', vehicleIdentityPartnerId);
          }
          const response = await axiosClient.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          const { result, reason, excelBase64 } = response;
          if (result === 'success') {
            return true;
          }
          const invalidResult = buildInvalidResult({ excelBase64, reason });
          if (invalidResult) {
            return invalidResult;
          }
          return reason || 'Tải lên thất bại';
        } catch (error) {
          const invalidResult = buildInvalidResult(error?.response?.data);
          if (invalidResult) {
            return invalidResult;
          }
          return error?.response?.data?.reason || 'Tải lên thất bại';
        }
      },
    },

    // ---- DASHBOARD ----
    Dashboard: {
      requestGetDailyData: async (params) => {
        const url = '/dashboard/daily';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, daily } = response;
          if (result === 'success') {
            return daily;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetRealtimeData: async (params) => {
        const url = '/dashboard/realtime';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, realtime } = response;
          if (result === 'success') {
            return realtime;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetStationStatistics: async (params) => {
        const url = '/dashboard/stationStatistics';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetPointStatistics: async (params) => {
        const url = '/dashboard/pointStatistics';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetPointSummary: async (params) => {
        const url = '/dashboard/pointSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, statuses } = response;
          if (result === 'success') {
            return {
              [ChargeConstants.ChargePointStatus.AVAILABLE]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.AVAILABLE
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.BUSY]:
                _.find(statuses, (item) => item.status === ChargeConstants.ChargePointStatus.BUSY)
                  ?.total || 0,
              [ChargeConstants.ChargePointStatus.FAULT]:
                _.find(statuses, (item) => item.status === ChargeConstants.ChargePointStatus.FAULT)
                  ?.total || 0,
              [ChargeConstants.ChargePointStatus.MAINTAINING]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.MAINTAINING
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.DISCONNECTED]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.DISCONNECTED
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.RESERVED]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.RESERVED
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.DISABLE]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.DISABLE
                )?.total || 0,
            };
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetAgencyStatistics: async (params) => {
        const url = '/dashboard/agencyStatistics';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, agencies } = response;
          if (result === 'success') {
            return {
              // [AgencyConstants.AgencyRole.GROUP]:
              //   _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.GROUP)
              //     ?.count || 0,
              [AgencyConstants.AgencyRole.SALE]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.SALE)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.INVESTOR]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.INVESTOR)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.COINVESTOR]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.COINVESTOR)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.LANDLORD]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.LANDLORD)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.CHARGEPOINT]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.CHARGEPOINT)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.FLEET]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.FLEET)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.VOUCHER_PARTNER]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.VOUCHER_PARTNER)
                  ?.count || 0,
            };
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetRevenueSummary: async (params) => {
        const url = '/dashboard/revenueSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyGroupCommission: async (params) => {
        const url = '/dashboard/getMonthlyGroupCommission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, investments } = response;
          if (result === 'success') {
            return investments;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyLandlordCommission: async (params) => {
        const url = '/dashboard/getMonthlyLandlordCommission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetLandlordSummary: async (params) => {
        const url = '/dashboard/landlordSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyInvestorCommission: async (params) => {
        const url = '/dashboard/getMonthlyInvestorCommission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyStationEnergy: async (params) => {
        const url = '/dashboard/getMonthlyStationEnergy';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, monthlyEnergy } = response;
          if (result === 'success') {
            return monthlyEnergy;
          }
          return null;
        } catch (error) {
          return null;
        }
      },
    },

    // MARK: ---- TUTORIAL ----
    Tutorial: {
      requestGetTutorialList: async (params) => {
        const url = '/tutorial';
        try {
          const response = await axiosClient.get(url, {
            params,
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result, tutorials, total } = response;
          if (result === 'success') {
            return { tutorials, total };
          }
          return { tutorials: [], total: 0 };
        } catch (error) {
          return { tutorials: [], total: 0 };
        }
      },
      requestCreateTutorial: async (params) => {
        const url = '/tutorial';
        try {
          const response = await axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result, tutorial, reason } = response;
          if (result === 'success') {
            return tutorial;
          }
          return reason;
        } catch (error) {
          throw error?.response?.data?.reason || 'Thêm hướng dẫn sử dụng thất bại';
        }
      },
      requestUpdateTutorial: async (tutorialId, params) => {
        const url = `/tutorial/${tutorialId}`;
        try {
          const response = await axiosClient.put(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          throw error?.response?.data?.reason || 'Cập nhật hướng dẫn sử dụng thất bại';
        }
      },
      requestDeleteTutorial: async (tutorialId) => {
        const url = `/tutorial/${tutorialId}`;
        try {
          const response = await axiosClient.delete(url, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          throw error?.response?.data?.reason || 'Xoá hướng dẫn sử dụng thất bại';
        }
      },
    },

    // MARK: ---- NOTIFICATION ----
    Notification: {
      // lay danh sach thong bao
      requestGetNotificationList: async (params) => {
        const url = '/notification';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, notifications, total } = response;
          if (result === 'success') {
            return { notifications, total };
          }
          return { notifications: [], total: 0 };
        } catch (error) {
          return { notifications: [], total: 0 };
        }
      },
      // lay chi tiet thong bao
      requestGetNotificationDetail: async (notificationId) => {
        const url = `/notification/${notificationId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, notification } = response;
          if (result === 'success') {
            return notification;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them thong bao
      requestAddNotification: async (data) => {
        const url = '/notification/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm thông báo thất bại';
        }
      },
      // cap nhat thong bao
      requestUpdateNotification: async (notificationId, data) => {
        const url = `/notification/${notificationId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật thông báo thất bại';
        }
      },
      // xoa thong bao
      requestDeleteNotification: async (notificationId) => {
        const url = `/notification/${notificationId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa thông báo thất bại';
        }
      },
      // thong ke thong bao
      requestGetNotificationSummary: async (params) => {
        const url = '/notification/notificationSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, categories } = response;
          if (result === 'success') {
            return {
              [ChargeConstants.NotificationCategory.BUSINESS]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.BUSINESS
                )?.total || 0,
              [ChargeConstants.NotificationCategory.OPERATION]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.OPERATION)
                  ?.total || 0,
              [ChargeConstants.NotificationCategory.PROMOTION]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.PROMOTION)
                  ?.total || 0,
              [ChargeConstants.NotificationCategory.OTHER]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.OTHER
                )?.total || 0,
            };
          }
          return null;
        } catch (error) {
          return { categories: [] };
        }
      },
      // doc tat ca thong bao
      requestReadAllNotification: async (data) => {
        const url = '/notification/readAll';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Đọc tất cả thông báo thất bại';
        }
      },
    },
  },

  // MARK: ---- UTILS ----
  Utils: {
    // ---- USER ----
    // lay ten role cua user
    getUserRoleName: (role) => {
      switch (role) {
        case ChargeConstants.UserRole.ADMIN:
          return 'Quản trị viên';
        case ChargeConstants.UserRole.OPERATOR:
          return 'Nhà điều hành';
        case ChargeConstants.UserRole.AGENCY:
          return 'Đối tác';
        case ChargeConstants.UserRole.DRIVER:
          return 'Khách hàng';
        case ChargeConstants.UserRole.MAINTAINER:
          return 'Kỹ thuật viên';
        default:
          return '';
      }
    },
    // ---- MA DINH DANH ----
    getIdentifierStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeIdentifierStatus.ACTIVE:
          return 'Được phép sạc';
        case ChargeConstants.ChargeIdentifierStatus.INACTIVE:
          return 'Bị chặn';
        default:
          return '';
      }
    },
    getIdentifierStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeIdentifierStatus.ACTIVE:
          return 'success';
        case ChargeConstants.ChargeIdentifierStatus.INACTIVE:
          return 'danger';
        default:
          return 'secondary';
      }
    },
    buildChargeIdentifierListApiParams: (filter = {}) => {
      const { vehicleIdentityPartnerId, ...rest } = filter;
      const cleaned = _.pickBy(rest, (v) => v !== null && v !== undefined && v !== '');
      if (vehicleIdentityPartnerId === '' || vehicleIdentityPartnerId === undefined) {
        return cleaned;
      }
      if (vehicleIdentityPartnerId === null) {
        return { ...cleaned, vehicleIdentityPartnerId: 'null' };
      }
      return { ...cleaned, vehicleIdentityPartnerId };
    },
    // ---- RFID ----
    // lay ten trang thai the RFID
    getRFIDCardStatusName: (status) => {
      switch (status) {
        case ChargeConstants.RFIDCardStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.RFIDCardStatus.BLOCKED:
          return 'Bị khóa';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai the RFID
    getRFIDCardStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.RFIDCardStatus.NORMAL:
          return 'success';
        case ChargeConstants.RFIDCardStatus.BLOCKED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- WALLET TRANSACTIONS ----
    // lay ten trang thai giao dich vi
    getWalletTransactionStatusName: (status) => {
      switch (status) {
        case ChargeConstants.WalletTransactionStatus.PENDING:
          return 'Chờ thanh toán';
        case ChargeConstants.WalletTransactionStatus.COMPLETED:
          return 'Hoàn thành';
        case ChargeConstants.WalletTransactionStatus.CANCELLED:
          return 'Đã hủy';
        case ChargeConstants.WalletTransactionStatus.FAILED:
          return 'Thất bại';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai giao dich vi
    getWalletTransactionStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.WalletTransactionStatus.PENDING:
          return 'warning';
        case ChargeConstants.WalletTransactionStatus.COMPLETED:
          return 'success';
        case ChargeConstants.WalletTransactionStatus.CANCELLED:
          return 'danger';
        case ChargeConstants.WalletTransactionStatus.FAILED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- PAYMENT ----
    // lay ten trang thai thanh toan
    getPaymentStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargePaymentStatus.PENDING:
          return 'Chờ xác nhận';
        case ChargeConstants.ChargePaymentStatus.COMPLETED:
          return 'Đã thanh toán';
        case ChargeConstants.ChargePaymentStatus.FAILED:
          return 'Thất bại';
        case ChargeConstants.ChargePaymentStatus.CANCELLED:
          return 'Đã hủy';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai thanh toan
    getPaymentStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargePaymentStatus.PENDING:
          return 'warning';
        case ChargeConstants.ChargePaymentStatus.COMPLETED:
          return 'success';
        case ChargeConstants.ChargePaymentStatus.FAILED:
          return 'danger';
        case ChargeConstants.ChargePaymentStatus.CANCELLED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- KHACH HANG ----
    // lay ten trang thai khach hang
    getDriverStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeDriverStatus.REGISTERED:
          return 'Chờ kích hoạt';
        case ChargeConstants.ChargeDriverStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.ChargeDriverStatus.SUSPENDED:
          return 'Ngừng hoạt động';
        case ChargeConstants.ChargeDriverStatus.DELETED:
          return 'Đã xóa';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai khach hang
    getDriverStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeDriverStatus.REGISTERED:
          return 'primary';
        case ChargeConstants.ChargeDriverStatus.NORMAL:
          return 'success';
        case ChargeConstants.ChargeDriverStatus.SUSPENDED:
          return 'secondary';
        case ChargeConstants.ChargeDriverStatus.DELETED:
          return 'danger';
        default:
          return '';
      }
    },

    // lay ten loai gia sac
    getChargePricingTypeName: (price) => {
      switch (price) {
        case 0:
          return 'Tiêu chuẩn';
        case 1:
          return 'Miễn phí';
        default:
          return `Ưu đãi ${price * 100}%`;
      }
    },
    // lay mau sac cua loai gia sac
    getChargePricingTypeColor: (price) => {
      switch (price) {
        case 0:
          return 'success';
        case 1:
          return 'secondary';
        default:
          return 'primary';
      }
    },

    // lay ten loai giao dich
    getDriverTransactionName: (fundingSource) => {
      switch (fundingSource) {
        case 'INTERNAL':
        case 'CASH':
        case 'VNPAY':
        case 'BIDV':
        case 'MOMO':
          return 'Nạp tiền';
        case 'WALLET':
          return 'Chi tiền';
        case 'REFUND':
          return 'Hoàn tiền';
        default:
          return '';
      }
    },
    // ---- XE ----
    // lay ten trang thai xe
    getVehicleStatusName: (status) => {
      switch (status) {
        case ChargeConstants.VehicleStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.VehicleStatus.DELETED:
          return 'Đã xóa';
        case ChargeConstants.VehicleStatus.PENDING:
          return 'Chờ xác nhận';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai xe
    getVehicleStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.VehicleStatus.NORMAL:
          return 'success';
        case ChargeConstants.VehicleStatus.DELETED:
          return 'danger';
        case ChargeConstants.VehicleStatus.PENDING:
          return 'warning';
        default:
          return '';
      }
    },

    // ---- PHIEN SAC ----
    // lay ten trang thai phien sac
    getChargeTransactionStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeTransactionStatus.INITIATING:
          return 'Khởi tạo';
        case ChargeConstants.ChargeTransactionStatus.PREPARING:
          return 'Chuẩn bị';
        case ChargeConstants.ChargeTransactionStatus.CHARGING:
          return 'Đang sạc';
        case ChargeConstants.ChargeTransactionStatus.FINISHING:
          return 'Đang kết thúc';
        case ChargeConstants.ChargeTransactionStatus.FINISHED:
          return 'Đã kết thúc';
        case ChargeConstants.ChargeTransactionStatus.CANCELLED:
          return 'Đã hủy';
        case ChargeConstants.ChargeTransactionStatus.FAILED:
          return 'Lỗi';
        case ChargeConstants.ChargeTransactionStatus.RESERVED:
          return 'Đang đặt chỗ';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai phien sac
    getChargeTransactionStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeTransactionStatus.INITIATING:
          return 'primary';
        case ChargeConstants.ChargeTransactionStatus.PREPARING:
          return 'warning';
        case ChargeConstants.ChargeTransactionStatus.CHARGING:
          return 'success';
        case ChargeConstants.ChargeTransactionStatus.FINISHING:
          return 'success';
        case ChargeConstants.ChargeTransactionStatus.FINISHED:
          return 'secondary';
        case ChargeConstants.ChargeTransactionStatus.CANCELLED:
          return 'danger';
        case ChargeConstants.ChargeTransactionStatus.FAILED:
          return 'danger';
        case ChargeConstants.ChargeTransactionStatus.RESERVED:
          return 'primary';
        default:
          return '';
      }
    },
    // ---- TRAM SAC ----
    // lay pin icon tram sac
    getChargeStationPinIcon: (status) => {
      switch (status) {
        case ChargeConstants.ChargeStationStatus.NORMAL:
          return AppResource.icons.pin.normal;
        case ChargeConstants.ChargeStationStatus.MAINTAINING:
          return AppResource.icons.pin.maintaining;
        case ChargeConstants.ChargeStationStatus.PENDING:
          return AppResource.icons.pin.pending;
        case ChargeConstants.ChargeStationStatus.DISCONNECTED:
          return AppResource.icons.pin.disconnected;
        case ChargeConstants.ChargeStationStatus.STOPPED:
          return AppResource.icons.pin.stopped;
        case ChargeConstants.ChargeStationStatus.HIDDEN:
          return AppResource.icons.pin.hidden;
        default:
          return AppResource.icons.pin.normal;
      }
    },
    // lay ten trang thai tram sac
    getChargeStationStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeStationStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.ChargeStationStatus.MAINTAINING:
          return 'Đang bảo trì';
        case ChargeConstants.ChargeStationStatus.PENDING:
          return 'Đang lắp đặt';
        case ChargeConstants.ChargeStationStatus.DISCONNECTED:
          return 'Mất kết nối';
        case ChargeConstants.ChargeStationStatus.STOPPED:
          return 'Ngừng hoạt động';
        case ChargeConstants.ChargeStationStatus.HIDDEN:
          return 'Đang ẩn';
        case ChargeConstants.ChargeStationStatus.DELETED:
          return 'Đã xóa';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai tram sac
    getChargeStationStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeStationStatus.NORMAL:
          return 'success';
        case ChargeConstants.ChargeStationStatus.MAINTAINING:
          return 'warning';
        case ChargeConstants.ChargeStationStatus.PENDING:
          return 'primary';
        case ChargeConstants.ChargeStationStatus.DISCONNECTED:
          return 'danger';
        case ChargeConstants.ChargeStationStatus.STOPPED:
          return 'secondary';
        case ChargeConstants.ChargeStationStatus.HIDDEN:
          return 'info';
        case ChargeConstants.ChargeStationStatus.DELETED:
          return 'danger';
        default:
          return '';
      }
    },
    // lay ds cac loai tru sac trong 1 tram sac
    getChargeStationPointTypes: (chargeStation) => {
      return _.uniq(chargeStation?.chargePoints?.map((point) => point?.type))?.join(', ');
    },
    // lay tong so tru sac con trong trong 1 tram sac
    getChargeStationAvailablePoints: (chargePoints) => {
      return chargePoints?.length && chargePoints?.filter(
        (point) => point?.status === ChargeConstants.ChargePointStatus.AVAILABLE
      )?.length;
    },
    // lay dia chi day du cua tram sac
    getChargeStationFullAddress: (chargeStation) => {
      const areaTree = store.getState().app.areaTree;
      let address = chargeStation?.address ?? '';
      const area = ChargeHelper.Utils.getAreaById([areaTree], chargeStation?.areaId);
      if (area) {
        address += ', ' + area?.name ?? '';
        if (area?.typeCode === 'W') {
          const parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
          if (parentArea) {
            address += `, ${parentArea?.name ?? ''}`;
          }
        }
      }
      return address ?? '';
    },

    // ---- TRU SAC ----
    // lay ten trang thai tru sac
    getChargePointStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargePointStatus.AVAILABLE:
          return 'Sẵn sàng';
        case ChargeConstants.ChargePointStatus.BUSY:
          return 'Đang bận';
        case ChargeConstants.ChargePointStatus.FAULT:
          return 'Đang lỗi';
        case ChargeConstants.ChargePointStatus.MAINTAINING:
          return 'Bảo trì';
        case ChargeConstants.ChargePointStatus.DISCONNECTED:
          return 'Mất kết nối';
        case ChargeConstants.ChargePointStatus.RESERVED:
          return 'Đang đặt chỗ';
        case ChargeConstants.ChargePointStatus.DISABLE:
          return 'Vô hiệu hóa';
        default:
          return 'Không xác định';
      }
    },
    // lay mau sac cua trang thai tru sac
    getChargePointStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargePointStatus.AVAILABLE:
          return 'success';
        case ChargeConstants.ChargePointStatus.BUSY:
          return 'secondary';
        case ChargeConstants.ChargePointStatus.FAULT:
          return 'danger';
        case ChargeConstants.ChargePointStatus.MAINTAINING:
          return 'warning';
        case ChargeConstants.ChargePointStatus.DISCONNECTED:
          return 'danger';
        case ChargeConstants.ChargePointStatus.RESERVED:
          return 'primary';
        case ChargeConstants.ChargePointStatus.DISABLE:
          return 'danger';
        default:
          return '';
      }
    },

    // ---- Súng sạc ----
    // Lấy tên trạng thái súng sạc
    getChargeConnectorStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeConnectorStatus.AVAILABLE:
          return 'Sẵn sàng';
        case ChargeConstants.ChargeConnectorStatus.UNAVAILABLE:
          return 'Không khả dụng';
        case ChargeConstants.ChargeConnectorStatus.PREPARING:
          return 'Đang chuẩn bị';
        case ChargeConstants.ChargeConnectorStatus.CHARGING:
          return 'Đang sạc';
        case ChargeConstants.ChargeConnectorStatus.SUSPENDED:
          return 'Đang tạm dừng';
        case ChargeConstants.ChargeConnectorStatus.FINISHING:
          return 'Đang kết thúc';
        case ChargeConstants.ChargeConnectorStatus.FAULTED:
          return 'Lỗi';
        case ChargeConstants.ChargeConnectorStatus.RESERVED:
          return 'Đang đặt chỗ';
        default:
          return 'Không xác định';
      }
    },
    // lay mau sac cua trang thai sung sac
    getChargeConnectorStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeConnectorStatus.AVAILABLE:
          return 'success';
        case ChargeConstants.ChargeConnectorStatus.PREPARING:
          return 'info';
        case ChargeConstants.ChargeConnectorStatus.CHARGING:
          return 'primary';
        case ChargeConstants.ChargeConnectorStatus.SUSPENDED:
          return 'warning';
        case ChargeConstants.ChargeConnectorStatus.FINISHING:
          return 'danger';
        case ChargeConstants.ChargeConnectorStatus.FAULTED:
          return 'danger';
        case ChargeConstants.ChargeConnectorStatus.RESERVED:
          return 'primary';
        default:
          return '';
      }
    },
    // lay link QRCode cua voi sac
    getChargeConnectorQRCodeLink: (connector) => {
      const connectorId = connector?.connectorSerial ?? connector?.connectorId;
      const url = `${AppConfigs.env.domainUrl}/prepaid/qr/${connectorId}`;
      return url;
    },
    // lay link ocpp debug
    getChargePointOCPPDebugLink: (chargePoint) => {
      const url = `${AppConfigs.env.baseUrl}ocpp-logs/active/${chargePoint?.ocppId}.log`;
      return url;
    },

    // lay link QRCode cua the RFID
    getRFIDQRCodeLink: (serialNumber) => {
      const domainUrl = (AppConfigs.env.domainUrl || '').replace(/\/+$/, '');
      const url = `${domainUrl}/topup/${serialNumber}`;
      return url;
    },

    // ---- THONG BAO ----
    // lay faIcon cua loai thong bao
    getMessageLogTypeIcon: (type) => {
      switch (type) {
        case ChargeConstants.MessageLogType.INFO:
          return 'fa-solid fa-message-lines';
        case ChargeConstants.MessageLogType.NOTICE:
          return 'fa-solid fa-circle-info';
        case ChargeConstants.MessageLogType.WARNING:
          return 'fa-solid fa-triangle-exclamation';
        case ChargeConstants.MessageLogType.ERROR:
          return 'fa-solid fa-triangle-exclamation';
        default:
          return '';
      }
    },
    // lay ten loai thong bao
    getMessageLogTypeName: (type) => {
      switch (type) {
        case ChargeConstants.MessageLogType.INFO:
          return 'Thông tin';
        case ChargeConstants.MessageLogType.NOTICE:
          return 'Thông báo';
        case ChargeConstants.MessageLogType.WARNING:
          return 'Cảnh báo';
        case ChargeConstants.MessageLogType.ERROR:
          return 'Lỗi';
        default:
          return '';
      }
    },
    // lay mau sac cua loai thong bao
    getMessageLogTypeColor: (type) => {
      switch (type) {
        case ChargeConstants.MessageLogType.INFO:
          return 'info';
        case ChargeConstants.MessageLogType.NOTICE:
          return 'primary';
        case ChargeConstants.MessageLogType.WARNING:
          return 'warning';
        case ChargeConstants.MessageLogType.ERROR:
          return 'danger';
        default:
          return '';
      }
    },
    // lay ten cua loai voi sac
    getChargeConnectorTypeName: (type) => {
      switch (type) {
        case ChargeConstants.ChargeConnectorType.J1772:
          return 'J1772 - Type 1';
        case ChargeConstants.ChargeConnectorType.Mennekes:
          return 'Mennekes - Type 2';
        case ChargeConstants.ChargeConnectorType.GB_T:
          return 'GB/T';
        case ChargeConstants.ChargeConnectorType.CHAdeMO:
          return 'CHAdeMO';
        case ChargeConstants.ChargeConnectorType.CCS1:
          return 'CCS1';
        case ChargeConstants.ChargeConnectorType.CCS2:
          return 'CCS2';
        case ChargeConstants.ChargeConnectorType.Tesla:
          return 'Tesla';
        case ChargeConstants.ChargeConnectorType.AC:
          return 'Smart AC Socket';
        default:
          return '';
      }
    },

    // MARK: ---- AREA ----
    // lay thong tin khu vuc tu cay de quy khu vuc
    getAreaById: (areaTree, id) => {
      if (!areaTree) return null;
      const stack = [...areaTree];
      while (stack.length) {
        const node = stack.pop();
        if (node.areaId == id) {
          return node;
        }
        if (node.subAreas) {
          stack.push(...node.subAreas);
        }
      }
      return null;
    },
    // lay ds khu vuc theo type tu cay de quy khu vuc
    getAreaListByType: (areaTree, typeCode) => {
      if (!areaTree) return [];
      const stack = [...areaTree];
      const result = [];
      while (stack.length) {
        const node = stack.pop();
        if (node.typeCode == typeCode) {
          result.push(node);
        }
        if (node.subAreas) {
          stack.push(...node.subAreas);
        }
      }
      return result;
    },
    // lay ds khu vuc con theo parentId tu cay de quy khu vuc
    getSubAreaListByParentId: (areaTree, parentId) => {
      if (!areaTree) return [];
      const stack = [...areaTree];
      const result = [];
      while (stack.length) {
        const node = stack.pop();
        if (node.parentId == parentId) {
          result.push(node);
        }
        if (node.subAreas) {
          stack.push(...node.subAreas);
        }
      }
      return result;
    },
    // lay ten trang thai tai khoan dien luc
    getEnergyAccountStatusName: (status) => {
      switch (status) {
        case ChargeConstants.EnergyAccountStatus.PENDING:
          return 'Chờ phê duyệt';
        case ChargeConstants.EnergyAccountStatus.VALIDATED:
          return 'Đã phê duyệt';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai tai khoan dien luc
    getEnergyAccountStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.EnergyAccountStatus.PENDING:
          return 'danger';
        case ChargeConstants.EnergyAccountStatus.VALIDATED:
          return 'success';
        default:
          return '';
      }
    },

    // ---- TUTORIAL ----
    // lay ten trang thai huong dan su dung
    getTutorialStatusName: (status) => {
      switch (status) {
        case ChargeConstants.TutorialStatus.NORMAL:
          return 'Hoạt động';
        case ChargeConstants.TutorialStatus.DELETED:
          return 'Đang ẩn';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai huong dan su dung
    getTutorialStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.TutorialStatus.NORMAL:
          return 'success';
        case ChargeConstants.TutorialStatus.DELETED:
          return 'info';
        default:
          return '';
      }
    },
    // lay ten loai gia sac xe
    getDriverPricingTypeName: (discountRate) => {
      switch (discountRate) {
        case ChargeConstants.ChargeDriverPricingType.STANDARD:
          return 'Tiêu chuẩn';
        case ChargeConstants.ChargeDriverPricingType.DISCOUNT:
          return 'Ưu đãi';
        case ChargeConstants.ChargeDriverPricingType.FREE:
          return 'Miễn phí';
        default:
          return '';
      }
    },
    // MARK: ---- NOTIFICATION ----
    // lay ten trang thai thong bao
    getNotificationStatusName: (status) => {
      switch (status) {
        case ChargeConstants.NotificationStatus.SCHEDULED:
          return 'Đã lên lịch';
        case ChargeConstants.NotificationStatus.SENT:
          return 'Đã gửi';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai thong bao
    getNotificationStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.NotificationStatus.SCHEDULED:
          return 'info';
        case ChargeConstants.NotificationStatus.SENT:
          return 'primary';
        default:
          return '';
      }
    },
    // lay ten danh muc thong bao
    getNotificationCategoryName: (category) => {
      switch (category) {
        case ChargeConstants.NotificationCategory.BUSINESS:
          return 'Kinh doanh';
        case ChargeConstants.NotificationCategory.OPERATION:
          return 'Vận hành';
        case ChargeConstants.NotificationCategory.PROMOTION:
          return 'Khuyến mãi';
        case ChargeConstants.NotificationCategory.CHARGE:
          return 'Sạc xe & Giao dịch';
        case ChargeConstants.NotificationCategory.OTHER:
          return 'Khác';
        case ChargeConstants.NotificationCategory.EVG:
          return 'EVG';
        default:
          return '';
      }
    },
    // lay ten nguoi nhan
    getNotificationReceiverName: (role) => {
      switch (role) {
        case ChargeConstants.UserRole.DRIVER:
          return 'Tất cả tài xế';
        case ChargeConstants.UserRole.AGENCY:
          return 'Tất cả đối tác';
        case AgencyConstants.AgencyRole.SALE:
          return 'Tất cả đại lý';
        case AgencyConstants.AgencyRole.INVESTOR:
          return 'Tất cả NĐT nhượng quyền';
        case AgencyConstants.AgencyRole.GROUP:
          return 'Tất cả NĐT liên kết';
        case AgencyConstants.AgencyRole.LANDLORD:
          return 'Tất cả chủ mặt bằng';
        default:
          return '';
      }
    },
    // lay ten phuong thuc thanh toan
    getChargePaymentMethodName: (method) => {
      switch (method) {
        case ChargeConstants.ChargePaymentMethod.WALLET:
          return 'Ví điện tử';
        case ChargeConstants.ChargePaymentMethod.CASH:
          return 'Tiền mặt';
        case ChargeConstants.ChargePaymentMethod.QR:
          return 'Mã QR';
        case ChargeConstants.ChargePaymentMethod.VNPAY:
          return 'VNPAY QR';
        case ChargeConstants.ChargePaymentMethod.MOMO:
          return 'Ví MoMo';
        case ChargeConstants.ChargePaymentMethod.INTERNAL:
          return 'Nạp nội bộ';
        case ChargeConstants.ChargePaymentMethod.REFUND:
          return 'Hoàn tiền';
        default:
          return method;
      }
    },
  },

  // MARK: ---- NAVIGATION ----
  Navigation: {
    // chuyen den man them tram sac
    navigateToAddChargeStation: (router) => {
      if (router) {
        router.navigate(`${AppRoute.stationList}/add`);
      }
    },
    // chuyen den man chinh sua tram sac
    navigateToEditChargeStation: (router, chargeStationId) => {
      if (router) {
        router.navigate(`${AppRoute.stationList}/${chargeStationId}/edit`);
      }
    },
    // chuyen den man chi tiet tram sac
    navigateToChargeStationDetail: (router, chargeStationId) => {
      if (router) {
        router.navigate(`${AppRoute.stationList}/${chargeStationId}`);
      } else {
        Utils.openInNewTab(`${AppRoute.stationList}/${chargeStationId}`);
      }
    },
  },

  // MARK: ---- UI ----
  UI: {
    // ---- PRICING ----
    Pricing: {
      // hien dialog xac nhan xoa dinh gia
      showDialogConfirmDeletePricing: (pricingDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá định giá"
            contentEl={
              <>
                Bạn có chắc muốn xoá định giá:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {pricingDetail?.pricingId}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              try {
                const result = await ChargeHelper.API.requestDeleteChargePricing(
                  pricingDetail?.pricingId
                );
                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Xoá định giá thành công');
                  if (onDone) {
                    onDone();
                  }
                } else {
                  ToastHelper.showError(result || 'Xoá định giá thất bại');
                }
              } catch (error) {
                if (_.isString(error)) {
                  ToastHelper.showError(error);
                }
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // ---- TRAM SAC ----
    // hien dialog xac nhan xoa tram sac
    showDialogConfirmDeleteChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá trạm sạc"
          contentEl={
            <>
              Bạn có chắc muốn xoá trạm sạc{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.name}
              </span>
              {' '}không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            try {
              const result = await ChargeHelper.API.requestDeleteChargeStation(
                chargeStationDetail?.stationId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá trạm sạc thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá trạm sạc thất bại');
              }
            } catch (error) {
              if (_.isString(error)) {
                ToastHelper.showError(error);
              }
            }
          }}
          confirmButtonText='Xóa'
          confirmButtonRed={true}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan ngung hoat dong tram sac
    showDialogConfirmStopChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogStopChargeStationView
          item={chargeStationDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan bao tri tram sac
    showDialogConfirmMaintainChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogMaintainStation} />}
          title="Bảo trì trạm sạc"
          contentEl={
            <>
              Bạn có chắc muốn chuyển trạng thái trạm sạc {' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.name}{' '}
              </span>
              thành "Bảo trì" không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              { status: ChargeConstants.ChargeStationStatus.MAINTAINING }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Chuyển trạng thái trạm sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Chuyển trạng thái trạm sạc thất bại');
            }
          }}
          confirmButtonText='Bảo trì'
          confirmButtonRed={true}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan hoan thanh bao tri tram sac
    showDialogConfirmCompleteMaintainChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogCompleteMaintainStation} />}
          title="Hoàn thành bảo trì"
          contentEl={
            <>
              Hệ thống sẽ chuyển trạm sạc sang trạng thái {' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                Đang hoạt động,{' '}
              </span>
              cho phép toàn bộ thông tin và các tính năng của trạm trở lại vận hành bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              { status: ChargeConstants.ChargeStationStatus.NORMAL }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Chuyển trạng thái trạm sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Chuyển trạng thái trạm sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan an tram sac
    showDialogConfirmHideChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogHideStation} />}
          title="Ẩn trạm sạc"
          contentEl={
            <>
              Trạm sạc sau khi ẩn sẽ không hiện trên ứng dụng của khách hàng.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              { status: ChargeConstants.ChargeStationStatus.HIDDEN }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Ẩn trạm sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Ẩn trạm sạc thất bại');
            }
          }}
          confirmButtonText='Ẩn'
          confirmButtonRed={true}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan bo an tram sac
    showDialogConfirmUnhideChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogUnhideStation} />}
          title="Bỏ ẩn trạm sạc"
          contentEl={
            <>
              Hệ thống sẽ khôi phục hiển thị trạm sạc này tới danh sách các trạm sạc đang hoạt động, mọi thông tin và tính năng của trạm sạc sẽ hoạt động lại bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              { status: ChargeConstants.ChargeStationStatus.NORMAL }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Bỏ ẩn trạm sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Bỏ ẩn trạm sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan khoi phuc hoat dong tram sac
    showDialogConfirmRestoreChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
          title="Khôi phục hoạt động trạm sạc"
          contentEl={
            <>
              Bạn có chắc muốn khôi phục hoạt động trạm sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}
                onClick={() => { }}
              >
                {chargeStationDetail?.name}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              {
                status: ChargeConstants.ChargeStationStatus.NORMAL,
                reason: null,
                operationalDate: null,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Khôi phục hoạt động trạm sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Khôi phục hoạt động trạm sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // ---- TRU SAC ----
    // hien dialog xac nhan xoa tru sac
    showDialogConfirmDeleteChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá trụ sạc"
          contentEl={
            <>
              Bạn có chắc muốn xoá trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargePoint(
              chargePointDetail?.pointId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan khoi dong lai tru sac
    showDialogConfirmRestartChargePoint: (chargePointDetail, onDone) => {
      const isDisabled =
        chargePointDetail?.status === ChargeConstants.ChargePointStatus.DISABLE;
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogRefreshGreen} />}
          title="Khởi động lại trụ sạc"
          cancelButtonText="Hủy bỏ"
          confirmButtonText="Xác nhận"
          contentEl={
            isDisabled ? (
              <>
                Bạn có chắc muốn khởi động lại trụ sạc{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}
                  onClick={() => { }}
                >
                  {chargePointDetail?.pointCode}
                </span>
                .<br /> Hệ thống sẽ cho phép các chức năng của trụ và giao dịch sạc xe diễn ra bình thường?
              </>
            ) : (
              <>
                Bạn có chắc muốn khởi động lại trụ sạc{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}
                  onClick={() => { }}
                >
                  {chargePointDetail?.pointCode}
                </span>
                {' '}không?
              </>
            )
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            let result;
            if (isDisabled) {
              result = await ChargeHelper.API.requestChangeAvailabilityChargePoint(chargePointDetail?.pointId, 1);
              if (result && _.isBoolean(result)) {
                const updateResult = await ChargeHelper.API.requestUpdateChargePoint(chargePointDetail?.pointId, {
                  status: ChargeConstants.ChargePointStatus.AVAILABLE,
                  reason: null,
                });
                if (!updateResult?.success) {
                  ToastHelper.showError(updateResult?.reason || 'Cập nhật trụ sạc thất bại');
                  return;
                }
              }
            } else {
              result = await ChargeHelper.API.requestRestartChargePoint(chargePointDetail?.pointId);
            }
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Khởi động lại trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Khởi động lại trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan thiet lap gioi han cong suat cua tru sac
    showDialogConfirmSetPowerLimitChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <ChargePointSetLimitPowerView
          chargePointDetail={chargePointDetail}
          title="Thiết lập công suất trụ sạc"
          contentEl={
            <>
              Nhập mức công suất giới hạn cho trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              ?
            </>
          }
          iconEl={<img src={AppResource.images.dialogIcons.dialogLimitPower} />}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async (powerLimit) => {
            AppCustomDialogHelper.hide();
            console.log({ powerLimit });
            const result = await ChargeHelper.API.requestSetChargePointPowerLimit(
              chargePointDetail?.pointId,
              powerLimit
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Thiết lập công suất trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Thiết lập công suất trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan di chuyen tru sac
    showDialogConfirmMoveChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogMovePointView
          chargePointDetail={chargePointDetail}
          title="Di chuyển trụ sạc"
          contentEl={<>Vui lòng chọn thông tin trạm sạc mà bạn muốn di chuyển trụ sạc tới</>}
          iconEl={<img src={AppResource.images.dialogIcons.dialogMovePoint} />}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async (stationId) => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargePoint(
              chargePointDetail?.pointId,
              {
                stationId: stationId,
              }
            );
            if (result?.success) {
              ToastHelper.showSuccess('Di chuyển trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result?.reason || 'Di chuyển trụ sạc thất bại');
            }
          }}
        />,
        'md',
        false,
        true
      );
    },
    // hien dialog xac nhan thay doi tram sac
    showDialogConfirmChangeChargeStation: (chargeStationDetail, callback) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
          title="Thay đổi trạm sạc quản lý"
          contentEl={
            <>
              Bạn có chắc muốn thay đổi trạm sạc quản lý hiện tại thành trạm sạc{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.item?.stationCode ?? 'Không xác định'}
              </span>
              không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
            callback(false);
          }}
          onConfirm={() => {
            AppCustomDialogHelper.hide();
            callback(true);
          }}
          confirmButtonRed={true}
          confirmButtonText="Thay đổi"
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan bao loi tru sac
    showDialogConfirmReportErrorChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogReportErrorChargePointView
          item={chargePointDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    showDialogChargePointErrorDescription: (chargePointDetail) => {
      AppCustomDialogHelper.show(
        '',
        <DialogChargePointErrorDescriptionView
          item={chargePointDetail}
          onDismiss={() => AppCustomDialogHelper.hide()}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan khoi phuc hoat dong tru sac
    showDialogConfirmRestoreChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogRefresh} />}
          title="Khôi phục hoạt động trụ sạc"
          contentEl={
            <>
              Bạn có chắc muốn khôi phục hoạt động của trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargePoint(
              chargePointDetail?.pointId,
              {
                status: ChargeConstants.ChargePointStatus.AVAILABLE,
                reason: null,
              }
            );
            if (result?.success) {
              ToastHelper.showSuccess('Khôi phục hoạt động trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result?.reason || 'Khôi phục hoạt động trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan vo hieu hoa tru sac
    showDialogConfirmDeactivateChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeactivateChargePoint} />}
          title="Vô hiệu hóa"
          confirmButtonText="Vô hiệu hóa"
          confirmButtonRed={true}
          contentEl={
  <>
    Bạn có chắc muốn vô hiệu hóa trụ sạc{' '}
    <span
      className="cursor-pointer hover-opacity-60"
      style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}
      onClick={() => {}}
    >
      {chargePointDetail?.pointCode}
    </span>
    ?
    <br />
    Trong quá trình vô hiệu hóa, hệ thống sẽ ngắt dòng sạc, khóa súng sạc,... và không cho phép diễn ra các giao dịch sạc xe?
  </>
}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestChangeAvailabilityChargePoint(
              chargePointDetail?.pointId,
              0
            );
            if (result && _.isBoolean(result)) {
              const updateResult = await ChargeHelper.API.requestUpdateChargePoint(chargePointDetail?.pointId, {
                status: ChargeConstants.ChargePointStatus.DISABLE,
                reason: null,
              });
              if (updateResult?.success) {
                ToastHelper.showSuccess('Vô hiệu hóa trụ sạc thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(updateResult?.reason || 'Vô hiệu hóa trụ sạc thất bại');
              }
            } else {
              ToastHelper.showError(result || 'Vô hiệu hóa trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog lich su cap nhat firmware
    showDialogFirmwareHistory: (chargePointDetail) => {
      AppCustomDialogHelper.show(
        '',
        <FirmwareHistoryView
          item={chargePointDetail}
          pointId={chargePointDetail?.pointId}
          onDismiss={() => AppCustomDialogHelper.hide()}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog cap nhat firmware
    showDialogUpdateFirmware: (chargePointDetail, onDone, onNavigateDetail) => {
      AppCustomDialogHelper.show(
        '',
        <DialogUpdateFirmwareView
          item={chargePointDetail}
          onCancel={() => AppCustomDialogHelper.hide()}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) onDone();
          }}
          onNavigateDetail={() => {
            AppCustomDialogHelper.hide();
            if (onNavigateDetail) onNavigateDetail();
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan hoan thanh bao tri
    showDialogConfirmCompleteMaintaining: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogCompleteMaintainStation} />}
          title="Hoàn thành bảo trì"
          contentEl={
            <>
              Hệ thống sẽ chuyển trạm sạc sang trạng thái {' '}
              <span
                style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
              >
                Đang hoạt động,
              </span>
              {' '} cho phép toàn bộ thông tin và các tính năng của trạm trở lại vận hành bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargePoint(
              chargePointDetail?.pointId,
              {
                status: ChargeConstants.ChargePointStatus.AVAILABLE,
              }
            );
            if (result?.success) {
              ToastHelper.showSuccess('Xác nhận hoàn thành bảo trì thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result?.reason || 'Xác nhận hoàn thành bảo trì thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // ---- VOI SAC ----
    // hien dialog xac nhan xoa voi sac
    showDialogConfirmDeleteChargeConnector: (chargeConnectorDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá súng sạc"
          contentEl={
            <>
              Bạn có chắc muốn xoá súng sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                Súng sạc {chargeConnectorDetail?.connectorNumber}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargeConnector(
              chargeConnectorDetail?.pointId,
              chargeConnectorDetail?.connectorId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá súng sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá súng sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan dung sac
    showDialogConfirmStopChargeConnector: (chargeConnectorDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogStopCharge} />}
          title="Dừng sạc"
          confirmButtonRed={true}
          contentEl={
            <>
              Hệ thống sẽ ngắt cấp điện và ngừng kết nối súng sạc để hoàn tất phiên sạc. Bạn có chắc
              chắn muốn dừng sạc không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestStopChargeConnector(
              chargeConnectorDetail?.pointId,
              chargeConnectorDetail?.connectorNumber
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Dừng sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Dừng sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan kich hoat voi sac
    showDialogConfirmActivateChargeConnector: (chargePricing, chargeConnectorDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogActivateChargeConnectorView
          pricing={chargePricing}
          item={chargeConnectorDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'lg',
        false,
        true
      );
    },

    // ---- DOI TAC SAC ----
    showDialogConfirmDeleteChargeIdentityPartner: (partner, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xóa đối tác sạc"
          contentEl={
            <>
              Bạn có chắc muốn xóa đối tác sạc{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray700)}>
                {partner?.name}
              </span>{' '}
              không?
            </>
          }
          cancelButtonText="Hủy bỏ"
          confirmButtonText="Xóa"
          confirmButtonRed={true}
          onCancel={() => { AppCustomDialogHelper.hide(); }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargeIdentityPartner(partner?.vehicleIdentityPartnerId);
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xóa đối tác sạc thành công');
              if (onDone) onDone();
            } else {
              ToastHelper.showError(result || 'Xóa đối tác sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // ---- HANG SAN XUAT TRU SAC ----
    // hien dialog xac nhan xoa hang san xuat tru sac
    showDialogConfirmDeleteChargeBrand: (chargeBrand, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá hãng sản xuất trụ sạc"
          contentEl={
            <>
              Bạn có chắc muốn xoá hãng sản xuất trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargeBrand?.name}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargeBrand(chargeBrand?.brandId);
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá hãng sản xuất trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá hãng sản xuất trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // ---- DONG TRU SAC ----
    // hien dialog xac nhan xoa dong tru sac
    showDialogConfirmDeleteChargeModel: (chargeModel, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá dòng trụ sạc"
          contentEl={
            <>
              Bạn có chắc muốn xoá dòng trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargeModel?.name}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargeModel(chargeModel?.modelId);
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá model trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá model trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // ---- TAI KHOAN DIEN LUC ----
    // hien dialog xac nhan xoa tai khoan dien luc
    showDialogConfirmDeleteEnergyAccount: (energyAccount, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá tài khoản điện lực"
          contentEl={
            <>
              Bạn có chắc muốn xoá tài khoản điện lực:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {energyAccount?.evnCustomerId}
              </span>
              {' '}không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteEnergyAccount(
              energyAccount?.energyAccountId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá tài khoản điện lực thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá tài khoản điện lực thất bại');
            }
          }}
          confirmButtonRed={true}
          confirmButtonText='Xóa'
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan phe duyet tai khoan dien luc
    showDialogConfirmApproveEnergyAccount: (energyAccount, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
          title="Phê duyệt tài khoản điện lực"
          contentEl={
            <>
              Bạn có chắc muốn phê duyệt tài khoản điện lực:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {energyAccount?.evnCustomerId}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateEnergyAccount(
              energyAccount?.energyAccountId,
              { status: ChargeConstants.EnergyAccountStatus.VALIDATED }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Phê duyệt tài khoản điện lực thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Phê duyệt tài khoản điện lực thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // MARK: ---- HANG XE ----
    VehicleBrand: {
      // hien dialog xac nhan xoa hang xe
      showDialogConfirmDeleteVehicleBrand: (vehicleBrand, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá hãng xe"
            contentEl={
              <>
                Bạn có chắc muốn xoá hãng xe:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {vehicleBrand?.name}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result =
                await ChargeHelper.API.ChargeVehicleBrand.requestDeleteChargeVehicleBrand(
                  vehicleBrand?.brandId
                );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá hãng xe thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá hãng xe thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- DONG XE ----
    VehicleModel: {
      // hien dialog xac nhan xoa dong xe
      showDialogConfirmDeleteVehicleModel: (vehicleBrandId, vehicleModel, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá dòng xe"
            contentEl={
              <>
                Bạn có chắc muốn xoá dòng xe:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray600)}
                  onClick={() => { }}
                >
                  {vehicleModel?.name}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result =
                await ChargeHelper.API.ChargeVehicleModel.requestDeleteChargeVehicleModel(
                  vehicleBrandId,
                  vehicleModel?.modelId
                );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá dòng xe thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá dòng xe thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- XE ----
    Vehicle: {
      // hien dialog xac nhan xoa xe
      showDialogConfirmDeleteVehicle: (vehicle, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá xe"
            contentEl={
              <>
                Bạn có chắc muốn xoá xe:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {vehicle?.plate}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Vehicle.requestDeleteVehicle(
                vehicle?.vehicleId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá xe thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá xe thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan bat/tat sac nhan dien xe
      showDialogConfirmTogglePlugAndCharge: (vehicle, onDone) => {
        const isSmart =
          vehicle?.chargingMode === ChargeConstants.VehicleChargingMode.SMART ||
          vehicle?.autoCharge === true;
        if (!isSmart) {
          const vehicleIdentityId =
            vehicle?.vehicleIdentityId ?? vehicle?.vehicleIdentity?.vehicleIdentityId ?? null;
          if (!Utils.isValid(vehicleIdentityId)) {
            ToastHelper.showWarning(ChargeConstants.VehicleFlugChargeRequiresRegistrationMessage);
            return;
          }
        }
        const newMode = isSmart
          ? ChargeConstants.VehicleChargingMode.NORMAL
          : ChargeConstants.VehicleChargingMode.SMART;
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={
              <img src={isSmart
                ? AppResource.images.dialogIcons.dialogError
                : AppResource.images.dialogIcons.dialogSuccess
              } />
            }
            title={isSmart ? 'Tắt sạc nhận diện xe' : 'Bật sạc nhận diện xe'}
            contentEl={
              <>
                Bạn có chắc muốn {isSmart ? 'tắt' : 'bật'} tính năng sạc nhận diện xe (Plug &amp; Charge) cho xe{' '}
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray600)}>
                  [{vehicle?.plate}]
                </span>
                {' '}không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText={isSmart ? 'Tắt' : 'Xác nhận'}
            confirmButtonRed={isSmart}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Vehicle.requestUpdateVehicle(
                vehicle?.vehicleId,
                {
                  brandId: vehicle?.model?.brandId,
                  modelId: vehicle?.modelId,
                  vehicleType: vehicle?.vehicleType,
                  plate: vehicle?.plate,
                  vinNumber: vehicle?.vinNumber || null,
                  userId: vehicle?.userId,
                  chargingMode: newMode,
                  evccId: vehicle?.evccId || null,
                }
              );
              if (result) {
                ToastHelper.showSuccess(
                  isSmart
                    ? 'Đã tắt sạc nhận diện xe (Plug & Charge)'
                    : 'Đã bật sạc nhận diện xe (Plug & Charge)'
                );
                if (onDone) onDone();
              } else {
                ToastHelper.showError('Có lỗi xảy ra');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan doi the RFID
      showDialogConfirmChangeRFID: (vehicle, onDone) => {
        const cards = vehicle?.cards;
        const modeChangeCard = cards?.length > 1;
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={
              <img
                src={
                  modeChangeCard
                    ? AppResource.images.dialogIcons.dialogChangeCard
                    : AppResource.images.dialogIcons.dialogProvideCard
                }
              />
            }
            title={modeChangeCard ? 'Đổi thẻ RFID' : 'Cấp mới thẻ RFID'}
            contentEl={
              modeChangeCard ? (
                <>
                  Bạn có chắc muốn đổi lại thẻ RFID này không? <br />
                  Sau khi đổi thẻ RFID cũ sẽ bị thu hồi và thay thế bằng thẻ RFID mới.
                </>
              ) : (
                <>
                  Chọn thẻ RFID cho xe:{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                    {vehicle?.plate}
                  </span>
                  , và nhấn xác nhận để hoàn thành
                </>
              )
            }
            bodyEl={
              <DialogChangeRfidCardView
                vehicle={vehicle}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
    },

    // MARK: ---- RFID ----
    RFID: {
      // hien dialog xac nhan thu hoi the RFID
      showDialogConfirmRevokeRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRevokeCard} />}
            title="Thu hồi thẻ RFID"
            contentEl={
              <>
                Bạn có chắc muốn thu hồi thẻ RFID này không? <br />
                Thẻ RFID sẽ bị thu hồi và không thể sử dụng nữa.
              </>
            }
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestUpdateRFIDCard(rfid?.rfidId, {
                vehicleId: null,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Thu hồi thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Thu hồi thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khoi phuc the RFID
      showDialogConfirmRestoreRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidRestore} />}
            title="Khôi phục thẻ RFID"
            contentEl={
              <>
                Bạn có chắc muốn khôi phục hoạt động thẻ RFID:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestUpdateRFIDCard(rfid?.rfidId, {
                status: ChargeConstants.RFIDCardStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khôi phục thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khôi phục thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khoa the RFID
      showDialogConfirmLockRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidLock} />}
            title="Khoá thẻ RFID"
            confirmButtonRed={true}
            contentEl={
              <>
                Bạn có chắc muốn khoá thẻ RFID:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestUpdateRFIDCard(rfid?.rfidId, {
                status: ChargeConstants.RFIDCardStatus.BLOCKED,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khoá thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khoá thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan xoa the RFID
      showDialogConfirmDeleteRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá thẻ RFID"
            confirmButtonRed={true}
            contentEl={
              <>
                Bạn có chắc muốn xoá thẻ RFID:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestDeleteRFIDCard(rfid?.rfidId);
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- MA DINH DANH ----
    Identifier: {
      showDialogConfirmDeleteIdentifier: (identifier, onDone) => {
        const plate = identifier?.vehicle?.plate;
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogIdentifierDelete} />}
            title="Xóa mã định danh"
            confirmButtonRed={true}
            confirmButtonText="Xóa"
            contentEl={
              plate ? (
                <>
                  Sau khi xóa, hệ thống sẽ gỡ liên kết mã MAC/EVCC khỏi xe{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                    {plate}
                  </span>
                  , bạn vẫn muốn tiếp tục?
                </>
              ) : (
                <>
                  Bạn có chắc muốn xóa mã định danh{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                    {identifier?.code}
                  </span>{' '}
                  không?
                </>
              )
            }
            onCancel={() => { AppCustomDialogHelper.hide(); }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Identifier.requestDeleteIdentifier(identifier?.vehicleIdentityId);
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xóa mã định danh thành công');
                if (onDone) onDone();
              } else {
                ToastHelper.showError(result || 'Xóa mã định danh thất bại');
              }
            }}
          />,
          'md', true, true
        );
      },
      showDialogConfirmBlockIdentifier: (identifier, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidLock} />}
            title="Chặn sạc"
            confirmButtonRed={true}
            cancelButtonText="Bỏ qua"
            confirmButtonText="Chặn sạc"
            contentEl={
              <>
                Bạn có chắc muốn chặn sạc xe có mã định danh{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}>
                  {identifier?.code}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => { AppCustomDialogHelper.hide(); }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Identifier.requestUpdateIdentifierStatus(
                [identifier?.vehicleIdentityId],
                ChargeConstants.ChargeIdentifierStatus.INACTIVE,
                'Chặn sạc mã định danh thất bại'
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Chặn sạc mã định danh thành công');
                if (onDone) onDone();
              } else {
                ToastHelper.showError(result || 'Chặn sạc mã định danh thất bại');
              }
            }}
          />,
          'md', true, true
        );
      },
      showDialogConfirmAllowIdentifier: (identifier, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidRestore} />}
            title="Cấp phép sạc"
            cancelButtonText="Bỏ qua"
            confirmButtonText="Cấp phép"
            contentEl={
              <>
                Bạn có chắc muốn cấp phép sạc cho xe có mã định danh{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray600)}>
                  {identifier?.code}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => { AppCustomDialogHelper.hide(); }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Identifier.requestUpdateIdentifierStatus(
                [identifier?.vehicleIdentityId],
                ChargeConstants.ChargeIdentifierStatus.ACTIVE,
                'Cấp phép sạc cho mã định danh thất bại'
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Cấp phép sạc cho mã định danh thành công');
                if (onDone) onDone();
              } else {
                ToastHelper.showError(result || 'Cấp phép sạc cho mã định danh thất bại');
              }
            }}
          />,
          'md', true, true
        );
      },
      showDialogConfirmBulkAllowIdentifier: (ids, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidRestore} />}
            title="Cấp phép sạc"
            cancelButtonText="Bỏ qua"
            confirmButtonText="Cấp phép"
            contentEl={
              <>
                Bạn có chắc muốn cấp phép sạc cho{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {ids.length}
                </span>{' '}
                mã định danh đã chọn không?
              </>
            }
            onCancel={() => { AppCustomDialogHelper.hide(); }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Identifier.requestAllowBatchIdentifiers(ids);
              if (result === true) {
                ToastHelper.showSuccess(`Cấp phép sạc thành công cho ${ids.length} mã`);
                if (onDone) onDone();
              } else {
                ToastHelper.showError(_.isString(result) ? result : 'Cấp phép sạc cho mã định danh thất bại');
              }
            }}
          />,
          'md', true, true
        );
      },
      showDialogConfirmBulkBlockIdentifier: (ids, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidLock} />}
            title="Chặn sạc"
            confirmButtonRed={true}
            cancelButtonText="Bỏ qua"
            confirmButtonText="Chặn sạc"
            contentEl={
              <>
                Bạn có chắc muốn chặn sạc{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {ids.length}
                </span>{' '}
                mã định danh đã chọn không?
              </>
            }
            onCancel={() => { AppCustomDialogHelper.hide(); }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Identifier.requestBlockBatchIdentifiers(ids);
              if (result === true) {
                ToastHelper.showSuccess(`Chặn sạc thành công cho ${ids.length} mã`);
                if (onDone) onDone();
              } else {
                ToastHelper.showError(_.isString(result) ? result : 'Chặn sạc mã định danh thất bại');
              }
            }}
          />,
          'md', true, true
        );
      },
      showDialogAssignVehicle: (identifier, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <DialogAssignVehicleView
            identifier={identifier}
            onCancel={() => AppCustomDialogHelper.hide()}
            onDone={() => {
              AppCustomDialogHelper.hide();
              if (onDone) onDone();
            }}
          />,
          'md', false, true
        );
      },
    },

    // MARK: ---- DRIVER ----
    Driver: {
      // hien dialog xac nhan xoa khach hang
      showDialogConfirmDeleteDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá khách hàng"
            contentEl={
              <>
                Bạn có chắc muốn xoá khách hàng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestDeleteDriver(driver?.userId);
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá khách hàng thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá khách hàng thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan ngung hoat dong khach hang
      showDialogConfirmSuspendDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogStopAgency} />}
            title="Ngừng hoạt động"
            contentEl={
              <>
                Bạn có chắc muốn ngừng hoạt động KH{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Ngừng hoạt động"
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestUpdateDriver(driver?.userId, {
                status: ChargeConstants.ChargeDriverStatus.SUSPENDED,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Ngừng hoạt động thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Ngừng hoạt động thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khoi phuc hoat dong khach hang
      showDialogConfirmResumeDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
            title="Khôi phục hoạt động"
            contentEl={
              <>
                Bạn có chắc muốn khôi phục hoạt động KH{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Khôi phục"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestUpdateDriver(driver?.userId, {
                status: ChargeConstants.ChargeDriverStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khôi phục khách hàng thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khôi phục khách hàng thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan kich hoat khach hang
      showDialogConfirmActivateDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogAcceptAgency} />}
            title="Kích hoạt tài khoản"
            contentEl={
              <>
                Bạn có chắc muốn kích hoạt tài khoản KH{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}{' '}
                </span>
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Kích hoạt"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestUpdateDriver(driver?.userId, {
                status: ChargeConstants.ChargeDriverStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Kích hoạt tài khoản thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Kích hoạt tài khoản thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog nap tien cho khach hang
      showDialogTopUpDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogTopUp} />}
            title="Nạp tiền cho khách hàng"
            contentEl={
              <>
                Nhập số tiền để nạp vào ví của khách hàng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>
              </>
            }
            bodyEl={
              <DialogTopUpDriverView
                driver={driver}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog dat gia sac xe cho khach hang
      showDialogSetChargingPrice: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogSetChargingPrice} />}
            title="Đặt giá sạc xe"
            contentEl={
              <>
                Chọn loại giá sạc được áp dụng cho khách hàng mỗi lần sạc xe.
              </>
            }
            bodyEl={
              <DialogSetChargingPriceView
                driver={driver}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog doi mat khau cho khach hang
      showDialogChangePasswordDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogChangePassword} />}
            title="Đặt lại mật khẩu"
            contentEl={
              <>
                Thay đổi mật khẩu đăng nhập cho tài khoản khách hàng
              </>
            }
            bodyEl={
              <DialogChangeAgencyPasswordView
                agency={driver}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog chi tiet giao dich
      showDialogTransactionDetail: (row, user, onDone) => {
        AppCustomDialogHelper.show(
          'Chi tiết giao dịch',
          <AgencySaleDialogView
            confirmButtonText={null}
            cancelButtonText="Bỏ qua"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onlyBodyEl={true}
            bodyEl={
              <DialogTransactionDetailView
                item={row}
                user={user}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
          />,
          'md',
          false,
          true
        );
      },
    },

    // MARK: ---- THIET BI ----
    Inventory: {
      showDialogConfirmDeleteCategory: (categoryDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá sản phẩm"
            contentEl={
              <>
                Bạn có chắc muốn xoá sản phẩm:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {categoryDetail?.name ?? ''}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              try {
                const result = await ChargeHelper.API.requestDeleteChargeInventoryCategory(
                  categoryDetail?.categoryId
                );
                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Xoá sản phẩm thành công');
                  if (onDone) {
                    onDone();
                  }
                } else {
                  ToastHelper.showError(result || 'Xoá sản phẩm thất bại');
                }
              } catch (error) {
                if (_.isString(error)) {
                  ToastHelper.showError(error);
                }
              }
            }}
          />,
          'md',
          true,
          true
        );
      },

      showDialogConfirmDeleteInventory: (inventoryDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá thiết bị"
            contentEl={
              <>
                Bạn có chắc muốn xoá thiết bị:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {inventoryDetail?.name ?? ''}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              try {
                const result = await ChargeHelper.API.requestDeleteChargeInventory(
                  inventoryDetail?.inventoryId
                );
                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Xoá thiết bị thành công');
                  if (onDone) {
                    onDone();
                  }
                } else {
                  ToastHelper.showError(result || 'Xoá thiết bị thất bại');
                }
              } catch (error) {
                if (_.isString(error)) {
                  ToastHelper.showError(error);
                }
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- EXCEL ----
    Excel: {
      showDialogUploadIdentifierExcel: (onDone = () => { }) => {
        AppCustomDialogHelper.show(
          'Tải lên dữ liệu excel',
          <DialogUploadIdentifierView
            key={Date.now()}
            onCancel={() => AppCustomDialogHelper.hide()}
            onDone={() => { AppCustomDialogHelper.hide(); onDone(); }}
          />,
          'md',
          false,
          true
        );
      },
      showDialogUploadIdentifierInvalidData: (excelBase64) => {
        AppCustomDialogHelper.show(
          '',
          <DialogUploadIdentifierInvalidDataView
            key={Date.now()}
            excelBase64={excelBase64}
            onCancel={() => AppCustomDialogHelper.hide()}
          />,
          'md',
          true,
          true
        );
      },
      // tai xuong file excel
      showDialogDownloadExcelFile: (filter, onDownload = () => {}) => {
        AppCustomDialogHelper.show(
          'Tải xuống',
          <DialogDownloadExcelFile
            key={Date.now()}
            filter={{ ...filter }}
            onDownload={onDownload}
          />,
          'md',
          false,
          true
        );
      },
    },

    // MARK: ---- NOTIFICATION ----
    Notification: {
      // hien thi dialog xac nhan an thong bao
      showDialogConfirmHideNotification: (notificationDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogHideNotification} />}
            title="Ẩn thông báo"
            contentEl={
              <>
                Bạc có chắc muốn ẩn thông báo {' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                  onClick={() => { }}
                >
                  {notificationDetail?.title}
                </span>
                {' '} không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Notification.requestUpdateNotification(
                notificationDetail?.notificationId,
                { public: 0 }
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Ẩn thông báo thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Ẩn thông báo thất bại');
              }
            }}
            confirmButtonRed={true}
          />,
          'md',
          true,
          true
        );
      },
      // hien thi dialog xac nhan hien thong bao
      showDialogConfirmShowNotification: (notificationDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
            title="Hiện thông báo"
            contentEl={
              <>
                Bạc có chắc muốn hiện thông báo {' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                  onClick={() => { }}
                >
                  {notificationDetail?.title}
                </span>
                {' '} không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Notification.requestUpdateNotification(
                notificationDetail?.notificationId,
                { public: 1 }
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Hiện thông báo thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Hiện thông báo thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien thi dialog xac nhan xoa thong bao
      showDialogConfirmDeleteNotification: (notificationDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xóa thông báo"
            contentEl={
              <>
                Bạc có chắc muốn xóa thông báo {' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                  onClick={() => { }}
                >
                  {notificationDetail?.title}
                </span>
                {' '} không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Notification.requestDeleteNotification(
                notificationDetail?.notificationId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xóa thông báo thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xóa thông báo thất bại');
              }
            }}
            confirmButtonRed={true}
          />,
          'md',
          true,
          true
        );
      },
    }
  },
};

export default ChargeHelper;
